/* PFD Garage — theme behaviour.
   Vanilla JS, no dependencies. Everything here degrades gracefully:
   with JS off the page is fully readable and every link still works. */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  /* ---------------------------------------------------------------- Nav */

  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]');
    var drawer = document.querySelector('[data-mobile-nav]');
    if (!toggle || !drawer) return;

    var closer = drawer.querySelector('[data-nav-close]');
    var lastFocused = null;
    var openers = document.querySelectorAll('[data-nav-open]');
    var groups = drawer.querySelectorAll('[data-nav-group]');
    var flyout = drawer.querySelector('[data-nav-flyout]');
    var wideMq = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;

    // One section open at a time. Opening Collections on a wide screen
    // widens the drawer to show the stripe art beside the list.
    function syncFlyout() {
      var coll = drawer.querySelector('[data-nav-group="collections"]');
      // The preview only appears once a collection name is hovered or focused.
      var on = !!(flyout && coll && coll.hasAttribute('open') && wideMq && wideMq.matches && flyoutWanted);
      drawer.classList.toggle('has-flyout', on);
      if (flyout) flyout.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (!on) {
        flyoutWanted = false;
        Array.prototype.forEach.call(drawer.querySelectorAll('[data-flyout-index]'), function (row) { row.classList.remove('is-active'); });
      }
    }
    var flyoutWanted = false;

    function showSlide(i) {
      if (!flyout) return;
      Array.prototype.forEach.call(flyout.querySelectorAll('[data-collection-slide]'), function (sl, n) {
        sl.classList.toggle('is-active', n === i);
        sl.setAttribute('tabindex', '-1');
      });
      Array.prototype.forEach.call(drawer.querySelectorAll('[data-flyout-index]'), function (row) {
        row.classList.toggle('is-active', +row.getAttribute('data-flyout-index') === i);
      });
    }

    Array.prototype.forEach.call(groups, function (g) {
      g.addEventListener('toggle', function () {
        if (g.hasAttribute('open')) {
          Array.prototype.forEach.call(groups, function (o) { if (o !== g) o.removeAttribute('open'); });
        }
        syncFlyout();
      });
    });
    if (wideMq && wideMq.addEventListener) wideMq.addEventListener('change', syncFlyout);

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-flyout-index]'), function (row) {
      var i = +row.getAttribute('data-flyout-index');
      function preview() { flyoutWanted = true; syncFlyout(); showSlide(i); }
      row.addEventListener('mouseenter', preview);
      row.addEventListener('focus', preview);
    });

    function setOpeners(group) {
      Array.prototype.forEach.call(openers, function (b) {
        b.setAttribute('aria-expanded', group && b.getAttribute('data-nav-open') === group ? 'true' : 'false');
      });
    }

    function open(group) {
      if (drawer.getAttribute('data-open') !== 'true') lastFocused = document.activeElement;
      var header = document.querySelector('.site-header');
      if (header) {
        header.classList.add('is-solid');
        document.documentElement.style.setProperty('--nav-top', Math.max(0, header.getBoundingClientRect().bottom) + 'px');
      }
      document.body.classList.add('nav-open');
      drawer.setAttribute('data-open', 'true');
      drawer.removeAttribute('aria-hidden');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var target = group ? drawer.querySelector('[data-nav-group="' + group + '"]') : null;
      Array.prototype.forEach.call(groups, function (g) {
        if (g === target) g.setAttribute('open', '');
        else g.removeAttribute('open');
      });
      syncFlyout();
      setOpeners(group);
      var first = target ? target.querySelector('summary') : drawer.querySelector('a, button');
      if (first) first.focus({ preventScroll: true });
    }

    function close() {
      drawer.setAttribute('data-open', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
      var header = document.querySelector('.site-header');
      if (header) header.classList.remove('is-solid');
      document.body.style.overflow = '';
      setOpeners(null);
      if (lastFocused) lastFocused.focus();
    }

    Array.prototype.forEach.call(openers, function (b) {
      b.addEventListener('click', function () {
        var group = b.getAttribute('data-nav-open');
        var target = drawer.querySelector('[data-nav-group="' + group + '"]');
        if (drawer.getAttribute('data-open') === 'true' && target && target.hasAttribute('open')) close();
        else open(group);
      });
    });

    toggle.addEventListener('click', function () {
      if (drawer.getAttribute('data-open') === 'true') close();
      else open(null);
    });

    if (closer) closer.addEventListener('click', close);
    var backdrop = document.querySelector('[data-nav-backdrop]');
    if (backdrop) backdrop.addEventListener('click', close);

    // Close after choosing a destination, including same-page anchors.
    drawer.addEventListener('click', function (event) {
      if (event.target.closest('a')) close();
    });
    // A sign-up from the drawer reloads to the success message: reopen the drawer to show it.
    if (location.hash === '#DrawerSignup' && drawer.querySelector('.mobile-nav__signup-ok')) open(null);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.getAttribute('data-open') === 'true') {
        close();
      }
    });

    // Keep focus inside the drawer while it is open.
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusables = drawer.querySelectorAll(
        'a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* --------------------------------------------------------- Shop menu */

  /* The <details>/<summary> dropdown (snippets/header-shop-menu.liquid)
     already opens/closes and is keyboard-operable with zero JS. This only
     adds two conveniences a native <details> doesn't do on its own: closing
     when something else is clicked, and closing on Escape (returning focus
     to the trigger so it isn't lost). */
  function initShopDropdown() {
    var dropdowns = document.querySelectorAll('[data-shop-dropdown]');
    if (!dropdowns.length) return;

    function closeAll(except) {
      Array.prototype.forEach.call(dropdowns, function (d) {
        if (d !== except && d.hasAttribute('open')) d.removeAttribute('open');
      });
    }

    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(dropdowns, function (d) {
        if (d.hasAttribute('open') && !d.contains(event.target)) {
          d.removeAttribute('open');
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      Array.prototype.forEach.call(dropdowns, function (d) {
        if (!d.hasAttribute('open')) return;
        d.removeAttribute('open');
        var summary = d.querySelector('summary');
        if (summary) summary.focus();
      });
    });

    // Only one open at a time.
    Array.prototype.forEach.call(dropdowns, function (d) {
      d.addEventListener('toggle', function () {
        if (d.hasAttribute('open')) closeAll(d);
      });
    });

    // Desktop pointer convenience: hover opens the panel, leaving closes it
    // after a short grace period (the panel hangs below the header, so the
    // pointer crosses a small gap). Keyboard and click behaviour are the
    // native <details> ones; nothing essential depends on hover.
    var hoverMq = window.matchMedia ? window.matchMedia('(min-width: 900px) and (hover: hover)') : null;
    Array.prototype.forEach.call(dropdowns, function (d) {
      if (!d.closest('.nav') || !hoverMq) return;
      var timer = null;
      var summary = d.querySelector('summary');
      d.addEventListener('mouseenter', function () {
        if (!hoverMq.matches) return;
        clearTimeout(timer);
        if (!d.hasAttribute('open')) {
          d.setAttribute('open', '');
          d.setAttribute('data-hover-opened', '');
        }
      });
      d.addEventListener('mouseleave', function () {
        if (!hoverMq.matches) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (d.hasAttribute('data-hover-opened')) {
            d.removeAttribute('open');
            d.removeAttribute('data-hover-opened');
          }
        }, 280);
      });
      if (summary) {
        // A click right after a hover-open would toggle it shut again.
        summary.addEventListener('click', function (event) {
          if (d.hasAttribute('data-hover-opened')) {
            event.preventDefault();
            d.removeAttribute('data-hover-opened');
          }
        });
      }
    });
  }

  /* --------------------------------------------------- Collections menu */

  /* Hovering or focusing a collection name swaps the hero panel to it.
     Otherwise, while the menu is open, the hero rotates every few seconds.
     Rotation pauses on hover/focus and never runs under reduced motion. */
  function initCollectionMenu() {
    var menus = document.querySelectorAll('[data-collection-menu]');
    Array.prototype.forEach.call(menus, function (menu) {
      var details = menu.closest('details');
      var links = menu.querySelectorAll('[data-collection-link]');
      var slides = menu.querySelectorAll('[data-collection-slide]');
      if (!details || links.length < 2 || links.length !== slides.length) return;

      var current = 0;
      var paused = false;
      var timer = null;

      function show(i) {
        current = i;
        Array.prototype.forEach.call(links, function (l, n) {
          l.classList.toggle('is-active', n === i);
        });
        Array.prototype.forEach.call(slides, function (s, n) {
          s.classList.toggle('is-active', n === i);
          // Only the visible slide is reachable by keyboard.
          s.setAttribute('tabindex', n === i ? '0' : '-1');
        });
      }

      function tick() {
        if (paused || prefersReducedMotion.matches) return;
        show((current + 1) % slides.length);
      }

      function start() {
        stop();
        if (prefersReducedMotion.matches) return;
        timer = setInterval(tick, 4500);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      Array.prototype.forEach.call(links, function (l, n) {
        l.addEventListener('mouseenter', function () { show(n); });
        l.addEventListener('focus', function () { show(n); });
      });

      menu.addEventListener('mouseenter', function () { paused = true; });
      menu.addEventListener('mouseleave', function () { paused = false; });
      menu.addEventListener('focusin', function () { paused = true; });
      menu.addEventListener('focusout', function (event) {
        if (!menu.contains(event.relatedTarget)) paused = false;
      });

      details.addEventListener('toggle', function () {
        if (details.hasAttribute('open')) {
          show(0);
          start();
        } else {
          stop();
        }
      });
    });
  }

  /* ------------------------------------------------ Collections showcase */

  /* sections/pfd-collection-showcase.liquid, after Art Book Next: one
     collection on stage at a time. The track slides by transform (not
     scroll-snap, which skips or sticks on programmatic jumps); swipe,
     the arrows, arrow keys and the name row (hover or click) move it. The
     active collection plays the stripe entrance and shows its products
     below. Neighbouring slides' stripe art is loaded ahead of time. */
  function initShowcase() {
    var sections = document.querySelectorAll('[data-showcase]');
    Array.prototype.forEach.call(sections, function (section) {
      var track = section.querySelector('[data-showcase-row]');
      var panels = section.querySelectorAll('[data-showcase-panel]');
      var tabs = section.querySelectorAll('[data-showcase-tab]');
      var grids = section.querySelectorAll('[data-showcase-grid]');
      if (!track || panels.length < 2) return;
      var count = panels.length;
      var current = 0;
      var hoverTimer = null;
      var counter = section.querySelector('[data-showcase-count]');

      function warm(i) {
        var p = panels[(i + count) % count];
        Array.prototype.forEach.call(p.querySelectorAll('img[loading="lazy"]'), function (img) {
          img.loading = 'eager';
        });
      }

      function go(i) {
        var n = (i + count) % count;
        current = n;
        track.style.setProperty('--at', n);
        Array.prototype.forEach.call(panels, function (p, k) {
          p.classList.toggle('is-active', k === n);
          p.setAttribute('tabindex', k === n ? '0' : '-1');
        });
        Array.prototype.forEach.call(tabs, function (b, k) {
          b.classList.toggle('is-active', k === n);
          b.setAttribute('aria-pressed', k === n ? 'true' : 'false');
        });
        Array.prototype.forEach.call(grids, function (g, k) {
          g.hidden = k !== n;
        });
        if (counter) counter.textContent = ('0' + (n + 1)).slice(-2) + ' / ' + ('0' + count).slice(-2);
        warm(n);
        warm(n + 1);
        warm(n - 1);
      }

      var prev = section.querySelector('[data-showcase-prev]');
      var next = section.querySelector('[data-showcase-next]');
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });

      Array.prototype.forEach.call(tabs, function (b, n) {
        b.addEventListener('click', function () { go(n); });
        b.addEventListener('mouseenter', function () {
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () { if (n !== current) go(n); }, 140);
        });
        b.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); });
      });

      section.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        if (!e.target.closest('[data-showcase-panel], [data-showcase-tab], [data-showcase-prev], [data-showcase-next]')) return;
        e.preventDefault();
        go(current + (e.key === 'ArrowRight' ? 1 : -1));
        var t = e.target.closest('[data-showcase-tab]') ? tabs[current] : panels[current];
        if (t) t.focus({ preventScroll: true });
      });

      // Swipe: follow the finger, then settle on the next or previous slide.
      var startX = 0;
      var startY = 0;
      var dx = 0;
      var dragging = false;
      var moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        startX = e.clientX;
        startY = e.clientY;
        dx = 0;
        dragging = true;
        moved = false;
      });
      track.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - startY)) {
          moved = true;
          track.classList.add('is-dragging');
        }
        if (moved) {
          track.style.transform = 'translateX(calc(' + (-current * 100) + '% + ' + dx + 'px))';
        }
      });
      function end() {
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        track.style.transform = '';
        if (moved && Math.abs(dx) > 50) go(current + (dx < 0 ? 1 : -1));
      }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
      // A swipe should not also follow the panel's link.
      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          moved = false;
        }
      }, true);

      warm(1);
      warm(count - 1);
    });
  }

  /* ------------------------------------------- Friends & Family pop-up */

  /* sections/pfd-friends-popup.liquid. Opens once after the set delay or
     after a third of the page is scrolled. Closing snoozes it; signing up
     keeps it away for a year. After a submit the page reloads with the
     result, so a success or an error reopens it straight away. Storage can
     be blocked (private windows): then it simply shows once per page view. */
  function initPopup() {
    var dialog = document.querySelector('[data-popup]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var KEY = 'pfd-friends-popup';
    var day = 86400000;

    function read() {
      try { return parseInt(window.localStorage.getItem(KEY) || '0', 10); } catch (e) { return 0; }
    }
    function snooze(days) {
      try { window.localStorage.setItem(KEY, String(Date.now() + days * day)); } catch (e) {}
    }
    function open() {
      if (dialog.open || document.querySelector('dialog[open]:not([data-popup])')) return;
      dialog.showModal();
    }

    // Every customer form on the page shares the posted result, so only
    // treat it as ours when Shopify returned to this form's anchor.
    var ours = window.location.hash === '#FriendsPopupForm';
    var success = ours && dialog.querySelector('[data-popup-success]');
    var error = ours && dialog.querySelector('[data-popup-error]');
    if (!ours && dialog.querySelector('[data-popup-success]')) snooze(365);
    if (success || error) {
      if (success) snooze(365);
      open();
    } else if (read() < Date.now()) {
      var opened = false;
      var delay = (parseInt(dialog.getAttribute('data-delay'), 10) || 10) * 1000;
      var go = function () {
        if (opened) return;
        opened = true;
        window.removeEventListener('scroll', onScroll);
        open();
      };
      var onScroll = function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && window.scrollY / max > 0.33) go();
      };
      setTimeout(go, delay);
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    function close() {
      if (!success) snooze(parseInt(dialog.getAttribute('data-snooze'), 10) || 21);
      dialog.close();
    }
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-popup-close]'), function (b) {
      b.addEventListener('click', close);
    });
    dialog.addEventListener('cancel', function () {
      if (!success) snooze(parseInt(dialog.getAttribute('data-snooze'), 10) || 21);
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });
    var form = dialog.querySelector('form');
    if (form) form.addEventListener('submit', function () { snooze(365); });
  }

  /* ------------------------------------------------------ Header swap */

  // Once the page scrolls past the top, the header wordmark crossfades to
  // "Poor Financial Decisions" over the Works bar (CSS does the motion; reduced
  // motion swaps instantly). Back near the top it returns to the wordmark.
  function initHeaderSwap() {
    var header = document.querySelector('.site-header');
    if (!header || !header.querySelector('[data-header-logo]')) return;
    var on = false;
    // Cheap check (one comparison), so it runs on every scroll event directly.
    function update() {
      var next = window.scrollY > 140;
      if (next !== on) {
        on = next;
        header.classList.toggle('is-scrolled', on);
        var strip = document.querySelector('.announcement');
        if (strip) strip.classList.toggle('is-scrolled', on);
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
    // Header height, so the homepage hero can slide up under the transparent header.
    function measure() {
      document.documentElement.style.setProperty('--pfd-header-h', header.offsetHeight + 'px');
      var ann = document.querySelector('.announcement');
      document.documentElement.style.setProperty('--pfd-announce-h', (ann ? ann.offsetHeight : 0) + 'px');
    }
    window.addEventListener('resize', measure, { passive: true });
    measure();
  }

  /* ------------------------------------------------------------- Reveal */

  function initReveal() {
    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    // Reduced motion, or no IntersectionObserver: show everything immediately.
    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      for (var i = 0; i < targets.length; i++) {
        targets[i].classList.add('is-revealed');
      }
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });

    // Index children of staggered groups so CSS can offset their delays.
    document.querySelectorAll('[data-reveal-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, index) {
        child.style.setProperty('--i', Math.min(index, 8));
      });
    });
  }

  /* -------------------------------------------------------- Collage rail */

  /* The rail itself (overflow-x:auto + scroll-snap + tabindex) is fully
     keyboard- and touch-operable with zero JS — this function exists only
     to power the two visible prev/next <button>s, since "click a button to
     scroll a container" has no CSS/HTML-only equivalent. Everything else
     about the slider (no autoplay, no focus trap, reduced-motion handling)
     is CSS/markup, not this. */
  function initCollageRail() {
    var rails = document.querySelectorAll('[data-collage-rail]');

    Array.prototype.forEach.call(rails, function (rail) {
      // 2026-10-19 (Patrick): two-row rails show in a random order on every
      // visit and always end on a full column. Wide tiles take two cells, so
      // an odd cell count leaves one tile alone at the end; hide one standard
      // tile (a different one each visit, thanks to the shuffle) to even it out.
      // Without JS the rail keeps the authored order.
      if (rail.classList.contains('collage__rail--2row')) {
        var items = Array.prototype.slice.call(rail.children).filter(function (el) {
          return el.classList.contains('collage__item');
        });
        for (var i = items.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = items[i]; items[i] = items[j]; items[j] = t;
        }
        // Wide tiles near the end leave holes (they need two free columns in one
        // row); keep them out of the last six slots. Simulated 20k shuffles: no holes.
        var isWide = function (el) {
          return el.classList.contains('collage__item--feature') || el.classList.contains('collage__item--band');
        };
        var tail = items.slice(-6), head = items.slice(0, -6);
        tail.filter(isWide).forEach(function (el) {
          head.splice(Math.floor(Math.random() * (head.length + 1)), 0, el);
        });
        items = head.concat(tail.filter(function (el) { return !isWide(el); }));
        items.forEach(function (el) { rail.appendChild(el); });
        var cells = 0;
        items.forEach(function (el) {
          var wide = el.classList.contains('collage__item--feature') || el.classList.contains('collage__item--band');
          cells += wide ? 2 : 1;
        });
        if (cells % 2 === 1) {
          for (var k = items.length - 1; k >= 0; k--) {
            var c = items[k].classList;
            if (!c.contains('collage__item--feature') && !c.contains('collage__item--band')) {
              items[k].style.display = 'none';
              break;
            }
          }
        }
      }

      var scope = rail.closest('.container') || rail.parentElement;
      var prev = scope.querySelector('[data-collage-prev]');
      var next = scope.querySelector('[data-collage-next]');
      if (!prev && !next) return;

      function scrollByDirection(dir) {
        var amount = Math.round(rail.clientWidth * 0.75) * dir;
        rail.scrollBy({
          left: amount,
          // Reduced motion: jump instantly rather than merely shortening
          // the animation — matches the CSS rule that turns snapping off.
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      if (prev) prev.addEventListener('click', function () { scrollByDirection(-1); });
      if (next) next.addEventListener('click', function () { scrollByDirection(1); });
    });
  }

  /* ------------------------------------------------- Newsletter feedback */

  function initFormFocus() {
    // Shopify reloads with ?customer_posted=true after a successful signup.
    // Move focus to the confirmation so screen readers announce it.
    var status = document.querySelector('[data-form-status]');
    if (status) {
      status.setAttribute('tabindex', '-1');
      status.focus({ preventScroll: false });
    }
  }

  /* ----------------------------------------------------- Hero cross-fade */

  function initHeroCycle() {
    var heroes = document.querySelectorAll('[data-hero-cycle]');

    Array.prototype.forEach.call(heroes, function (hero) {
      var slides = hero.querySelectorAll('.hero__slide');
      if (slides.length < 2) return;

      // Optional — only present when the section rendered pfd-hero-indicators
      // (same slides.size > 1 && cycle gate as data-hero-cycle itself, so the
      // two collections are always the same length when indicators exist).
      var indicators = hero.querySelectorAll('.hero__indicator');

      var seconds = parseInt(hero.getAttribute('data-cycle-seconds'), 10) || 4;
      var index = 0;
      var timer = null;

      function advance() {
        slides[index].classList.remove('is-active');
        if (indicators[index]) indicators[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
        if (indicators[index]) indicators[index].classList.add('is-active');
      }

      function start() {
        // Reduced motion means no cycling at all — the first image just stays.
        if (timer || prefersReducedMotion.matches) return;
        timer = setInterval(advance, seconds * 1000);
      }

      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      start();

      // Pause while someone is looking at or interacting with the hero, and
      // while the tab is in the background.
      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      // Honour the preference changing mid-session.
      if (prefersReducedMotion.addEventListener) {
        prefersReducedMotion.addEventListener('change', function (event) {
          if (event.matches) stop();
          else start();
        });
      }
    });
  }

  /* ------------------------------------------------------ Product gallery */

  /* Slides use the same is-active convention as the hero (see
     .product-gallery__slide / initHeroCycle above) so a JS-off visitor still
     sees the first image, full quality, no blank state. Thumbnails are the
     only thing this function needs to power — there is no autoplay here. */
  function initProductGallery() {
    var roots = document.querySelectorAll('[data-product-gallery]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    Array.prototype.forEach.call(roots, function (viewer) {
      var scope = viewer.closest('.product__gallery') || viewer.parentElement;
      var track = viewer.querySelector('[data-gallery-track]');
      // allSlides/allThumbs are every photo; slides/thumbs are the ones shown
      // for the selected colour (hidden ones leave the scroll track entirely,
      // so swipe, arrows, keys and counters only cycle the visible set).
      var allSlides = Array.prototype.slice.call(viewer.querySelectorAll('[data-gallery-slide]'));
      var allThumbs = Array.prototype.slice.call(scope.querySelectorAll('[data-gallery-thumb]'));
      var slides = allSlides.slice();
      var thumbs = allThumbs.slice();
      var thumbStrip = scope.querySelector('.product-gallery__thumbs');
      if (!track || !slides.length) return;

      var thumbLabel = thumbStrip && thumbStrip.getAttribute('data-thumb-label');
      function relabelThumbs() {
        if (!thumbLabel) return;
        thumbs.forEach(function (thumb, i) {
          thumb.setAttribute('aria-label', thumbLabel.replace('__I__', i + 1).replace('__N__', thumbs.length));
        });
      }

      var current = 0;
      Array.prototype.forEach.call(slides, function (slide, i) {
        if (slide.classList.contains('is-active')) current = i;
      });

      function width() { return track.clientWidth || 1; }

      // Mark slide + thumbnail state only; never moves the track.
      function mark(index) {
        current = index;
        Array.prototype.forEach.call(slides, function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          if (active) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
        Array.prototype.forEach.call(thumbs, function (thumb, i) {
          var active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
          if (active && thumbStrip) {
            // Keep the active thumbnail visible without moving the page.
            var left = thumb.offsetLeft - thumbStrip.offsetLeft;
            var right = left + thumb.offsetWidth;
            if (left < thumbStrip.scrollLeft) {
              thumbStrip.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
            } else if (right > thumbStrip.scrollLeft + thumbStrip.clientWidth) {
              thumbStrip.scrollTo({ left: right - thumbStrip.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          }
        });
      }

      // Glide the track to a slide.
      // Glide the track to a slide. The animation is driven here rather than
      // by the browser's smooth scroll, with snapping paused until it lands:
      // snap and smooth scroll fight each other after a mouse drag, which
      // made the release look choppy on desktop.
      var glideFrame = 0;
      function stopGlide() {
        if (glideFrame) window.cancelAnimationFrame(glideFrame);
        glideFrame = 0;
      }
      function activate(index, instant) {
        var n = slides.length;
        index = Math.max(0, Math.min(n - 1, index));
        mark(index);
        // Start loading the target photo now: a lazy image far down the track
        // (e.g. a variant's own photo) otherwise shows blank for a moment.
        var targetImg = slides[index].querySelector('img[loading="lazy"]');
        if (targetImg) targetImg.loading = 'eager';
        stopGlide();
        var to = index * width();
        var from = track.scrollLeft;
        if (instant || reduceMotion || Math.abs(to - from) < 1) {
          track.scrollLeft = to;
          track.classList.remove('is-dragging');
          return;
        }
        track.classList.add('is-dragging');
        var dist = Math.abs(to - from) / width();
        var duration = Math.min(650, 320 + 110 * dist);
        var t0 = performance.now();
        (function frame(now) {
          var p = Math.min(1, (now - t0) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          track.scrollLeft = from + (to - from) * eased;
          if (p < 1) {
            glideFrame = window.requestAnimationFrame(frame);
          } else {
            glideFrame = 0;
            track.classList.remove('is-dragging');
          }
        })(t0);
      }

      function step(delta) {
        var n = slides.length;
        activate((current + delta + n) % n);
      }

      // Start on the variant's slide without animating.
      if (current > 0) activate(current, true);

      // Follow native scrolling (touch swipe, trackpad) and update thumbs.
      var raf = 0;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = 0;
          var i = Math.round(track.scrollLeft / width());
          if (i !== current && i >= 0 && i < slides.length) mark(i);
        });
      }, { passive: true });

      Array.prototype.forEach.call(thumbs, function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumbs.indexOf(thumb));
        });
      });

      var prevBtn = viewer.querySelector('[data-gallery-prev]');
      var nextBtn = viewer.querySelector('[data-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

      // Mouse drag: the strip follows the pointer, then settles on the
      // nearest photo (a quick flick moves one photo). Touch uses native
      // scroll-snap, which is already smooth. The click after a drag is
      // swallowed so it does not open the full-screen zoom.
      var dragging = false, moved = false, startX = 0, startScroll = 0, lastX = 0, lastT = 0, velocity = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        stopGlide();
        dragging = true;
        moved = false;
        startX = lastX = e.clientX;
        lastT = performance.now();
        velocity = 0;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
        var now = performance.now();
        // Smoothed so one jittery mouse event does not decide the flick.
        if (now - lastT > 0) velocity = velocity * 0.6 + ((e.clientX - lastX) / (now - lastT)) * 0.4;
        lastX = e.clientX;
        lastT = now;
      });
      window.addEventListener('pointerup', function () {
        if (!dragging) return;
        dragging = false;
        // Snapping stays paused; activate() glides to the photo and turns it back on.
        if (performance.now() - lastT > 120) velocity = 0;
        var exact = track.scrollLeft / width();
        var target = Math.round(exact);
        if (Math.abs(velocity) > 0.4) target = velocity < 0 ? Math.ceil(exact) : Math.floor(exact);
        activate(target);
      });
      track.addEventListener('click', function (e) {
        if (moved) {
          e.stopPropagation();
          e.preventDefault();
          moved = false;
        }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Keep the current slide aligned if the viewer is resized.
      window.addEventListener('resize', function () { activate(current, true); });

      // Thumbnail strip: drag sideways with the mouse (touch scrolls
      // natively). Suppresses the click if the strip was dragged.
      if (thumbStrip) {
        var tDown = false, tStartX = 0, tStartScroll = 0, tMoved = false;
        thumbStrip.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          tDown = true;
          tMoved = false;
          tStartX = e.clientX;
          tStartScroll = thumbStrip.scrollLeft;
        });
        window.addEventListener('pointermove', function (e) {
          if (!tDown) return;
          var dx = e.clientX - tStartX;
          if (Math.abs(dx) > 5) tMoved = true;
          if (tMoved) thumbStrip.scrollLeft = tStartScroll - dx;
        });
        window.addEventListener('pointerup', function () { tDown = false; });
        thumbStrip.addEventListener('click', function (e) {
          if (tMoved) {
            e.stopPropagation();
            e.preventDefault();
            tMoved = false;
          }
        }, true);
        thumbStrip.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      // Exposed so initProductForm can move the gallery when a variant with
      // its own featured image is selected.
      // index = absolute media index; ignored if that photo is filtered out.
      viewer.__pfdActivateSlide = function (mediaIndex) {
        var vi = slides.indexOf(allSlides[mediaIndex]);
        if (vi >= 0) activate(vi);
      };

      // Show only the photos that name the chosen colour (plus any that name
      // none). A colour with no photos of its own falls back to everything.
      // preferMedia = absolute media index to land on if it is in the set.
      var colourKey = null;
      viewer.__pfdSetColour = function (colour, preferMedia, instant) {
        var key = colour ? '|' + String(colour).toLowerCase() + '|' : '';
        var keep = allSlides.filter(function (sl) {
          var c = sl.getAttribute('data-colours') || '';
          return !key || !c || c.indexOf(key) >= 0;
        });
        // A colour whose only matches are shared photos has no gallery of its own.
        var own = keep.filter(function (sl) { return sl.getAttribute('data-colours'); });
        if (!keep.length || !own.length) keep = allSlides.slice();
        var changed = key !== colourKey;
        colourKey = key;
        var target = allSlides[preferMedia];
        var first = keep.indexOf(target) >= 0 ? target : keep[0];
        allSlides.forEach(function (sl, i) {
          var show = keep.indexOf(sl) >= 0;
          sl.hidden = !show;
          if (allThumbs[i]) allThumbs[i].hidden = !show;
        });
        slides = keep;
        thumbs = allThumbs.filter(function (t, i) { return keep.indexOf(allSlides[i]) >= 0; });
        relabelThumbs();
        if (thumbStrip) thumbStrip.hidden = thumbs.length < 2;
        Array.prototype.forEach.call(viewer.querySelectorAll('[data-gallery-prev], [data-gallery-next]'), function (b) { b.hidden = slides.length < 2; });
        track.scrollLeft = 0;
        if (changed || preferMedia != null) activate(slides.indexOf(first), true);
      };
    });
  }

  /* ------------------------------------------------- Product zoom (lens) */

  /* Desktop-only hover magnifier over the active gallery image. Reuses one
     lens element across every slide instead of building one per image.
     Never runs on touch (no hover to trigger it, and pinch-zoom in the
     lightbox already covers that case), and never requests the hi-res
     source until a visitor actually hovers a zoom trigger. */
  function initProductZoomLens() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var wraps = document.querySelectorAll('[data-gallery-zoom-wrap]');
    if (!wraps.length) return;

    var lens = document.createElement('div');
    lens.className = 'product-gallery__lens';
    lens.setAttribute('aria-hidden', 'true');

    var zoomFactor = 2.5;
    var activeImg = null;

    function detach() {
      lens.style.display = 'none';
      if (lens.parentNode) lens.parentNode.removeChild(lens);
      activeImg = null;
    }

    function attach(wrap, trigger) {
      var img = wrap.querySelector('.product-gallery__media');
      var hiRes = trigger.getAttribute('data-zoom-src');
      if (!img || !hiRes) return;
      activeImg = img;
      lens.style.backgroundImage = 'url(' + hiRes + ')';
      lens.style.display = 'block';
      wrap.appendChild(lens);
    }

    function move(event) {
      if (!activeImg) return;
      var rect = activeImg.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        detach();
        return;
      }

      var lensSize = lens.offsetWidth || 220;
      var bgWidth = rect.width * zoomFactor;
      var bgHeight = rect.height * zoomFactor;
      // Wide photos sit whole (object-fit: contain): magnify the picture box, not the frame.
      var offX = 0, offY = 0;
      if (activeImg.classList.contains('is-wide') && activeImg.naturalWidth && activeImg.naturalHeight) {
        var ar = activeImg.naturalWidth / activeImg.naturalHeight;
        var boxW = Math.min(rect.width, rect.height * ar);
        var boxH = boxW / ar;
        offX = (rect.width - boxW) / 2;
        offY = (rect.height - boxH) / 2;
        bgWidth = boxW * zoomFactor;
        bgHeight = boxH * zoomFactor;
        if (x < offX || x > offX + boxW || y < offY || y > offY + boxH) { lens.style.display = 'none'; return; }
        lens.style.display = 'block';
      }
      var lensX = Math.min(Math.max(x - lensSize / 2, 0), Math.max(rect.width - lensSize, 0));
      var lensY = Math.min(Math.max(y - lensSize / 2, 0), Math.max(rect.height - lensSize, 0));

      lens.style.left = lensX + 'px';
      lens.style.top = lensY + 'px';
      lens.style.backgroundSize = bgWidth + 'px ' + bgHeight + 'px';
      lens.style.backgroundPosition =
        '-' + ((x - offX) * zoomFactor - lensSize / 2) + 'px -' + ((y - offY) * zoomFactor - lensSize / 2) + 'px';
    }

    Array.prototype.forEach.call(wraps, function (wrap) {
      var trigger = wrap.querySelector('[data-gallery-zoom-trigger]');
      if (!trigger) return;
      wrap.addEventListener('mouseenter', function () { attach(wrap, trigger); });
      wrap.addEventListener('mousemove', move);
      wrap.addEventListener('mouseleave', detach);
    });
  }

  /* --------------------------------------------- Product lightbox (zoom) */

  /* Full-screen viewer opened from any [data-gallery-zoom-trigger]. Builds
     its image list from those triggers' data-zoom-src/data-zoom-alt
     attributes (2600px sources), so the section only has to render the
     buttons once — no separate JSON blob to keep in sync. Supports desktop
     click-to-zoom-then-drag-to-pan and mobile pinch/pan/swipe, all with
     plain pointer/touch events (no library). */
  function initProductLightbox() {
    var lightbox = document.querySelector('[data-product-lightbox]');
    var triggers = document.querySelectorAll('[data-gallery-zoom-trigger]');
    if (!lightbox || !triggers.length) return;

    // Rebuilt on each open: photos hidden by the colour filter are skipped.
    var images = [];
    function shownTriggers() {
      return Array.prototype.filter.call(triggers, function (btn) {
        var slide = btn.closest('[data-gallery-slide]');
        return !(slide && slide.hidden);
      });
    }
    function toImage(btn) {
      return {
        src: btn.getAttribute('data-zoom-src'),
        small: btn.getAttribute('data-zoom-src-small') || btn.getAttribute('data-zoom-src'),
        alt: btn.getAttribute('data-zoom-alt') || '',
        // Per-image zoom ceiling: model/lifestyle shots are capped (1.5x) so
        // shoppers can read the graphic but not inspect fabric weave.
        maxZoom: parseFloat(btn.getAttribute('data-zoom-max')) || 4,
      };
    }

    // Phones open on a 1400px image (fast to swipe through) and only fetch
    // the 2600px source once the shopper pinches to zoom.
    var smallScreen = window.matchMedia && window.matchMedia('(max-width: 699px), (pointer: coarse)').matches;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var preloaded = {};
    function viewSrc(data) { return smallScreen ? data.small : data.src; }
    function preload(url) {
      if (!url || preloaded[url]) return;
      preloaded[url] = true;
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
    }
    function preloadNeighbours() {
      if (images.length < 2) return;
      preload(viewSrc(images[(currentIndex + 1) % images.length]));
      preload(viewSrc(images[(currentIndex - 1 + images.length) % images.length]));
    }
    // Swap to the full-size file only once it is decoded off-screen: swapping
    // the src mid-drag made the browser decode a 2600 px image during the
    // gesture, which stuttered on phones the first time a photo was zoomed.
    var decoded = {};
    function upgradeToFull() {
      var full = images[currentIndex].src;
      if (!smallScreen || imgEl.getAttribute('src') === full) return;
      var idx = currentIndex;
      function swap() { if (currentIndex === idx && imgEl.getAttribute('src') !== full) imgEl.src = full; }
      if (decoded[full]) { swap(); return; }
      if (decoded[full] === false) return;  // already decoding
      decoded[full] = false;
      var pre = new Image();
      pre.src = full;
      (pre.decode ? pre.decode() : Promise.resolve()).then(function () { decoded[full] = true; swap(); }, swap);
    }

    var stage = lightbox.querySelector('[data-lightbox-stage]');
    var imgEl = lightbox.querySelector('[data-lightbox-image]');
    var counter = lightbox.querySelector('[data-lightbox-counter]');
    var closeBtn = lightbox.querySelector('[data-lightbox-close]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var backdrop = lightbox.querySelector('[data-lightbox-backdrop]');
    if (!stage || !imgEl) return;

    var currentIndex = 0;
    var lastFocused = null;
    var zoomed = false;
    var scale = 1;
    var panX = 0;
    var panY = 0;

    function applyTransform() {
      imgEl.style.transform = zoomed
        ? 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')'
        : '';
    }

    function resetZoom() {
      zoomed = false;
      scale = 1;
      panX = 0;
      panY = 0;
      imgEl.style.transformOrigin = '';
      applyTransform();
      stage.classList.remove('is-zoomed');
    }

    function render(index) {
      currentIndex = (index + images.length) % images.length;
      var data = images[currentIndex];
      resetZoom();
      imgEl.src = viewSrc(data);
      imgEl.alt = data.alt;
      if (counter) counter.textContent = (currentIndex + 1) + ' / ' + images.length;
      if (prevBtn) prevBtn.disabled = images.length < 2;
      if (nextBtn) nextBtn.disabled = images.length < 2;
      preloadNeighbours();
    }

    // Swipe that follows the finger: the image slides off in the swipe
    // direction, the next one slides in from the other side.
    function slideTo(direction) {
      if (reduceMotion) {
        render(currentIndex + direction);
        return;
      }
      var width = stage.clientWidth || window.innerWidth;
      imgEl.style.transition = 'transform 0.16s ease-out';
      imgEl.style.transform = 'translateX(' + (-direction * width) + 'px)';
      window.setTimeout(function () {
        imgEl.style.transition = 'none';
        render(currentIndex + direction);
        imgEl.style.transform = 'translateX(' + (direction * width * 0.35) + 'px)';
        // Force a reflow so the next transition starts from the offset.
        void imgEl.offsetWidth;
        imgEl.style.transition = 'transform 0.2s ease-out';
        imgEl.style.transform = '';
        window.setTimeout(function () { imgEl.style.transition = ''; }, 220);
      }, 160);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key === 'ArrowRight') {
        render(currentIndex + 1);
        return;
      }
      if (event.key === 'ArrowLeft') {
        render(currentIndex - 1);
        return;
      }
      if (event.key === 'Tab') {
        var focusables = lightbox.querySelectorAll('button:not([disabled])');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    function open(index) {
      lastFocused = document.activeElement;
      render(index);
      lightbox.hidden = false;
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
      // Focus after the browser paints the now-visible dialog.
      window.requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus();
      });
    }

    function close() {
      lightbox.hidden = true;
      document.body.style.overflow = '';
      resetZoom();
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    Array.prototype.forEach.call(triggers, function (btn, index) {
      btn.addEventListener('click', function () {
        var shown = shownTriggers();
        images = shown.map(toImage);
        open(Math.max(0, shown.indexOf(btn)));
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    if (prevBtn) prevBtn.addEventListener('click', function () { render(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { render(currentIndex + 1); });

    // ---- Desktop: click to zoom in on the click point, drag to pan.
    stage.addEventListener('click', function (event) {
      if (event.target !== imgEl) return;
      if (zoomed) {
        resetZoom();
        return;
      }
      var rect = imgEl.getBoundingClientRect();
      var originX = ((event.clientX - rect.left) / rect.width) * 100;
      var originY = ((event.clientY - rect.top) / rect.height) * 100;
      imgEl.style.transformOrigin = originX + '% ' + originY + '%';
      zoomed = true;
      scale = Math.min(2.4, images[currentIndex].maxZoom);
      panX = 0;
      panY = 0;
      applyTransform();
      stage.classList.add('is-zoomed');
    });

    var dragging = false;
    var dragStartX = 0;
    var dragStartY = 0;

    imgEl.addEventListener('mousedown', function (event) {
      if (!zoomed) return;
      dragging = true;
      dragStartX = event.clientX - panX;
      dragStartY = event.clientY - panY;
      event.preventDefault();
    });
    window.addEventListener('mousemove', function (event) {
      if (!dragging) return;
      panX = event.clientX - dragStartX;
      panY = event.clientY - dragStartY;
      applyTransform();
    });
    window.addEventListener('mouseup', function () { dragging = false; });

    // ---- Mobile: pinch to zoom, drag to pan while zoomed, swipe to change
    // image while not zoomed.
    function touchDistance(touches) {
      var dx = touches[0].clientX - touches[1].clientX;
      var dy = touches[0].clientY - touches[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }

    var touchState = null;

    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length === 2) {
        touchState = {
          type: 'pinch',
          startDist: touchDistance(event.touches),
          startScale: scale,
        };
      } else if (event.touches.length === 1) {
        touchState = {
          type: 'pan',
          startX: event.touches[0].clientX,
          startY: event.touches[0].clientY,
          panX: panX,
          panY: panY,
          moved: false,
        };
      }
    }, { passive: true });

    stage.addEventListener('touchmove', function (event) {
      if (!touchState) return;

      if (touchState.type === 'pinch' && event.touches.length === 2) {
        upgradeToFull();
        imgEl.style.transition = 'none';  // follow the fingers exactly, no easing lag
        var dist = touchDistance(event.touches);
        scale = Math.min(Math.max(touchState.startScale * (dist / touchState.startDist), 1), images[currentIndex].maxZoom);
        zoomed = scale > 1.05;
        stage.classList.toggle('is-zoomed', zoomed);
        applyTransform();
        event.preventDefault();
      } else if (touchState.type === 'pan' && event.touches.length === 1) {
        var dx = event.touches[0].clientX - touchState.startX;
        var dy = event.touches[0].clientY - touchState.startY;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) touchState.moved = true;
        if (zoomed) {
          panX = touchState.panX + dx;
          panY = touchState.panY + dy;
          imgEl.style.transition = 'none';
          applyTransform();
          event.preventDefault();
        } else if (images.length > 1 && Math.abs(dx) > Math.abs(dy)) {
          // Not zoomed: drag the image sideways with the finger.
          imgEl.style.transition = 'none';
          imgEl.style.transform = 'translateX(' + dx + 'px)';
          touchState.dragging = true;
          event.preventDefault();
        }
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (event) {
      if (touchState && touchState.type === 'pan' && !zoomed && touchState.moved) {
        var lastTouch = event.changedTouches[0];
        var dx = lastTouch ? lastTouch.clientX - touchState.startX : 0;
        if (dx < -40) slideTo(1);
        else if (dx > 40) slideTo(-1);
        else if (touchState.dragging) {
          // Not far enough: settle back into place.
          imgEl.style.transition = 'transform 0.2s ease-out';
          imgEl.style.transform = '';
          window.setTimeout(function () { imgEl.style.transition = ''; }, 220);
        }
        touchState = null;
        return;
      }
      imgEl.style.transition = '';  // back to the CSS easing for taps and resets
      if (scale <= 1.05) resetZoom();
      touchState = null;
    });
  }

  /* -------------------------------------------------- Product buy form */

  /* Reads the variants JSON main-product.liquid embeds server-side (id,
     option values, pre-formatted price strings, availability, gallery
     position) and keeps the picker, price, hidden id input and gallery in
     sync — no fetch, no AJAX, no client-side money formatting. With this
     script blocked, the <noscript> variant <select> in the form still lets a
     customer choose and buy any variant; this only replaces that fallback
     when it can run. */
  function initProductForm() {
    var roots = document.querySelectorAll('[data-product-root]');

    Array.prototype.forEach.call(roots, function (root) {
      var script = root.querySelector('[data-product-variants-json]');
      var idInput = root.querySelector('[data-product-id-input]');
      var priceBlock = root.querySelector('[data-product-price]');
      var submitBtn = root.querySelector('[data-add-to-cart]');
      var submitText = root.querySelector('[data-add-to-cart-text]');
      var noscriptSelect = root.querySelector('.product__noscript-select');
      if (!script || !idInput) return;

      var variants;
      try {
        variants = JSON.parse(script.textContent);
      } catch (e) {
        return;
      }
      if (!variants.length) return;

      // The noscript <select> is redundant once this can run — it would
      // otherwise submit a second `id` field alongside the hidden input.
      if (noscriptSelect) noscriptSelect.hidden = true;

      var optionInputs = root.querySelectorAll('[data-option-position]');
      var gallery = root.querySelector('[data-product-gallery]');

      // Position (0-based) of the Colour option within a variant's options.
      var colourPos = -1;
      Array.prototype.forEach.call(root.querySelectorAll('[data-product-option][data-option-name]'), function (fs) {
        if (/^colou?r$/.test(fs.getAttribute('data-option-name'))) colourPos = parseInt(fs.getAttribute('data-product-option'), 10) - 1;
      });

      function selectedOptionValues() {
        var positions = {};
        Array.prototype.forEach.call(optionInputs, function (input) {
          if (input.checked) positions[input.getAttribute('data-option-position')] = input.value;
        });
        var values = [];
        Object.keys(positions)
          .sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); })
          .forEach(function (key) { values.push(positions[key]); });
        return values;
      }

      function findVariant(values) {
        for (var i = 0; i < variants.length; i++) {
          var options = variants[i].options || [];
          if (options.length !== values.length) continue;
          var match = true;
          for (var j = 0; j < options.length; j++) {
            if (options[j] !== values[j]) {
              match = false;
              break;
            }
          }
          if (match) return variants[i];
        }
        return null;
      }

      function renderPrice(variant) {
        if (!priceBlock) return;
        var html = '';
        if (variant.on_sale) {
          html +=
            '<span class="product__price-sale mono" data-price-sale-tag>' +
            (window.PFD_I18N && window.PFD_I18N.onSale ? window.PFD_I18N.onSale : 'Sale') +
            '</span>' +
            '<s class="product__price-compare" data-price-compare>' + variant.compare_at_price_formatted + '</s>' +
            '<span class="product__price-current" data-price-current>' + variant.price_formatted + '</span>';
        } else {
          html += '<span class="product__price-current" data-price-current>' + variant.price_formatted + '</span>';
        }
        if (!variant.available) {
          html +=
            '<span class="mono product__price-unavailable" data-price-unavailable>' +
            (window.PFD_I18N && window.PFD_I18N.soldOut ? window.PFD_I18N.soldOut : 'Sold out') +
            '</span>';
        }
        priceBlock.innerHTML = html;
      }

      function updateAvailabilityTags(values) {
        Array.prototype.forEach.call(optionInputs, function (input) {
          var position = input.getAttribute('data-option-position');
          var testValues = values.slice();
          var index = position - 1;
          testValues[index] = input.value;
          var match = findVariant(testValues);
          var soldout = !match || !match.available;
          var label = input.nextElementSibling;
          if (!label) return;
          label.classList.toggle('is-soldout', soldout);
          var tag = label.querySelector('[data-soldout-tag]');
          if (tag) tag.hidden = !soldout;
        });
      }

      function applyVariant(variant, options) {
        options = options || {};
        idInput.value = variant.id;
        // Keep the Shop Pay Installments banner quoting the selected variant.
        var installmentsInput = document.querySelector('[data-installments-id-input]');
        if (installmentsInput && installmentsInput.value !== String(variant.id)) {
          installmentsInput.value = variant.id;
          installmentsInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        renderPrice(variant);

        if (submitBtn) submitBtn.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? (window.PFD_I18N && window.PFD_I18N.addToCart ? window.PFD_I18N.addToCart : 'Add to cart')
            : (window.PFD_I18N && window.PFD_I18N.soldOut ? window.PFD_I18N.soldOut : 'Sold out');
        }

        if (gallery && gallery.__pfdSetColour && colourPos >= 0) {
          // Only this colour's photos; land on the variant's own photo if it is among them.
          gallery.__pfdSetColour(variant.options[colourPos], variant.featured_media_position ? variant.featured_media_position - 1 : null, options.initial);
        } else if (gallery && gallery.__pfdActivateSlide && variant.featured_media_position) {
          gallery.__pfdActivateSlide(variant.featured_media_position - 1);
        }

        if (!options.skipHistory && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      Array.prototype.forEach.call(optionInputs, function (input) {
        input.addEventListener('change', function () {
          var values = selectedOptionValues();
          updateAvailabilityTags(values);
          var variant = findVariant(values);
          if (variant) applyVariant(variant);
        });
      });

      // Initial state, so the option-availability tags are correct before
      // any interaction — the price/id/gallery are already right from the
      // server render.
      updateAvailabilityTags(selectedOptionValues());

      // Filter the gallery to the selected colour on load.
      if (colourPos >= 0 && gallery && gallery.__pfdSetColour) {
        var startVariant = findVariant(selectedOptionValues());
        if (startVariant) {
          gallery.__pfdSetColour(startVariant.options[colourPos], startVariant.featured_media_position ? startVariant.featured_media_position - 1 : null, true);
        }
      }
    });
  }

  /* ------------------------------------------------- Sticky add to cart */

  // Product page: once the buy form has scrolled out of view, a bar pinned to
  // the bottom keeps the price and Add to cart in reach. It mirrors the real
  // form (price, variant, button state) and submits it, so nothing else
  // about variants or the cart changes.
  function initStickyAddToCart() {
    var bar = document.querySelector('[data-sticky-atc]');
    var root = bar && bar.closest('[data-product-root]');
    var form = root && root.querySelector('#ProductForm');
    var submit = root && root.querySelector('[data-add-to-cart]');
    if (!bar || !form || !submit || !('IntersectionObserver' in window)) return;

    var btn = bar.querySelector('[data-sticky-add]');
    var btnText = bar.querySelector('[data-sticky-add-text]');
    var priceOut = bar.querySelector('[data-sticky-price]');
    var variantOut = bar.querySelector('[data-sticky-variant]');
    var thumb = bar.querySelector('[data-sticky-thumb]');
    var priceBlock = root.querySelector('[data-product-price]');
    var past = false;

    function sync() {
      var cur = priceBlock && priceBlock.querySelector('[data-price-current]');
      if (priceOut && cur) priceOut.textContent = cur.textContent;
      if (variantOut) {
        var picked = [];
        root.querySelectorAll('[data-option-position]').forEach(function (i) { if (i.checked) picked.push(i.value); });
        if (picked.length) variantOut.textContent = picked.join(' / ');
      }
      var t = root.querySelector('[data-add-to-cart-text]');
      if (btnText && t) btnText.textContent = t.textContent;
      btn.disabled = submit.disabled;
      var img = root.querySelector('.product-gallery__slide.is-active img');
      if (thumb && img && (img.currentSrc || img.src)) {
        thumb.removeAttribute('srcset');
        thumb.src = img.currentSrc || img.src;
      }
    }

    function show(on) {
      if (on === !bar.hidden) return;
      if (on) sync();
      bar.hidden = !on;
      document.documentElement.classList.toggle('has-sticky-atc', on);
    }

    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // Show only after the form has gone off the TOP of the screen.
      past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      show(past);
    }, { threshold: 0 }).observe(form);

    root.addEventListener('change', function () { setTimeout(sync, 60); });
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(sync);
      if (priceBlock) mo.observe(priceBlock, { childList: true, subtree: true, characterData: true });
      mo.observe(submit, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
    });
  }

  /* ------------------------------------------------------------ Load more */

  // Collection pages: a "Load more" button and a "Showing X of Y" count over
  // the real pagination links. Fetches the next page, appends its cards,
  // rebinds swatches (quick add is delegated) and keeps ?page=N in the URL.
  function initLoadMore() {
    var box = document.querySelector('[data-load-more]');
    var grid = document.querySelector('[data-load-more-grid]');
    if (!box || !grid || !window.fetch || !window.DOMParser) return;
    var btn = box.querySelector('[data-load-more-btn]');
    var count = box.querySelector('[data-load-more-count]');
    var total = parseInt(box.getAttribute('data-total'), 10) || 0;
    var first = parseInt(box.getAttribute('data-first'), 10) || 1;
    var last = parseInt(box.getAttribute('data-last'), 10) || 0;
    var page = parseInt(box.getAttribute('data-page'), 10) || 1;
    var nextUrl = box.getAttribute('data-next-url');
    var busy = false;
    var inflight = null;   // promise of the page fetch in progress, so a restore can wait on it
    var loaded = 1;        // pages now in the grid (the URL stays on page 1)

    // Landed on ?page=N (old link, or a refresh from before the URL stopped changing): with
    // infinite scroll that page shows only its own slice, so go to the whole grid instead.
    if (page > 1 && 'IntersectionObserver' in window) {
      try {
        var p1 = new URL(location.href);
        p1.searchParams.delete('page');
        location.replace(p1.toString());
        return;
      } catch (e) {}
    }

    box.hidden = false;
    document.documentElement.classList.add('has-load-more');

    function label() {
      count.textContent = 'Showing ' + (first > 1 ? first + '-' : '') + last + ' of ' + total;
    }

    if (!nextUrl) btn.hidden = true;

    // Infinite scroll, like aloyoga.com (Patrick, 2026-10-03): the next page
    // loads on its own as the grid's end comes near. The button stays as the
    // fallback (no IntersectionObserver, or a failed fetch).
    var auto = 'IntersectionObserver' in window;
    var near = false;
    if (auto) {
      btn.hidden = true;
      new IntersectionObserver(function (entries) {
        near = entries[0].isIntersecting;
        if (near) loadNext(false);
      }, { rootMargin: '0px 0px 900px 0px' }).observe(box);
      // Belt and braces: a plain scroll check too, in case the observer is held back.
      window.addEventListener('scroll', function () {
        if (busy || !nextUrl || !auto) return;
        near = box.getBoundingClientRect().top < window.innerHeight + 900;
        if (near) loadNext(false);
      }, { passive: true });
    }

    btn.addEventListener('click', function () { loadNext(true); });

    // Resolves true when a page was added, false when there was nothing to add or the
    // fetch failed. While a fetch is running it hands back that same promise.
    function loadNext(fromButton) {
      if (busy) return inflight || Promise.resolve(false);
      if (!nextUrl) return Promise.resolve(false);
      busy = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Loading...';
      var ok = false;
      inflight = fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-load-more-grid]');
          var nextBox = doc.querySelector('[data-load-more]');
          if (!nextGrid) throw new Error('grid');
          var added = [];
          Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
            var node = document.importNode(child, true);
            grid.appendChild(node);
            added.push(node);
          });
          page += 1;
          loaded += 1;
          last = nextBox ? (parseInt(nextBox.getAttribute('data-last'), 10) || last) : last;
          nextUrl = nextBox ? nextBox.getAttribute('data-next-url') : '';
          initCardSwatches(grid);
          label();
          // The URL deliberately stays on page 1 (Patrick 2026-10-07: a refresh on ?page=3 dropped
          // him onto page 3 alone with Previous/Next links and the earlier shirts "gone").
          // Only a deliberate click moves focus; auto-loading leaves it alone.
          var firstLink = fromButton && added.length && added[0].querySelector('a');
          if (firstLink) firstLink.focus({ preventScroll: true });
          if (!nextUrl) btn.hidden = true;
          ok = true;
        })
        .catch(function () {
          auto = false;
          btn.hidden = !nextUrl;
          count.textContent = 'Could not load more. Use the page links instead.';
          document.documentElement.classList.remove('has-load-more');
        })
        .then(function () {
          busy = false;
          inflight = null;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
          btn.textContent = 'Load more';
          // Still at the end of a short page: keep going.
          if (auto && near && nextUrl) setTimeout(function () { loadNext(false); }, 50);
          return ok;
        });
      return inflight;
    }

    /* ---- Remember where the shopper was (Patrick 2026-10-26) ----
       Click a product, press Back: only page 1 is in the HTML, so the browser lands short.
       On leaving for a product we store (sessionStorage, per collection URL incl. filters and
       sort) how many pages were loaded, which card, and where it sat on screen. On return we
       load pages 2..N through loadNext, then put that card back where it was, instantly.
       Fresh visits (link click, typed URL) never restore; only Back/Forward/reload do. */
    var KEY = 'pfd:grid-pos:' + location.pathname + location.search;
    var MAX_AGE = 2 * 60 * 60 * 1000;
    var savedByClick = false;
    var restoring = false;

    function store(rec) { try { sessionStorage.setItem(KEY, JSON.stringify(rec)); } catch (e) {} }
    function unstore() { try { sessionStorage.removeItem(KEY); } catch (e) {} }
    function recall() {
      try {
        var rec = JSON.parse(sessionStorage.getItem(KEY));
        if (rec && typeof rec.pages === 'number' && rec.t && Date.now() - rec.t < MAX_AGE) return rec;
      } catch (e) {}
      return null;
    }

    function cardFor(handle, variant) {
      var cards = grid.querySelectorAll('[data-product-card][data-handle]');
      var fallback = null;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-handle') !== handle) continue;
        if (!variant || cards[i].getAttribute('data-variant') === variant) return cards[i];
        fallback = fallback || cards[i];
      }
      return fallback;
    }

    function snapshot(card) {
      var rec = { pages: loaded, y: Math.round(window.scrollY), t: Date.now() };
      if (card) {
        rec.handle = card.getAttribute('data-handle');
        rec.variant = card.getAttribute('data-variant') || '';
        var top = Math.round(card.getBoundingClientRect().top);
        // A card that was off screen (quick view's link) is put back just under the header instead.
        rec.off = (top < 0 || top > window.innerHeight - 80) ? 110 : top;
      }
      return rec;
    }

    // Delegated on the document: cards arrive later via Load more, and the quick view
    // drawer's "full details" link goes to a product too.
    document.addEventListener('click', function (e) {
      if (restoring || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank') return;
      var m;
      try { m = new URL(a.href, location.href).pathname.match(/\/products\/([^\/?#]+)/); } catch (err) { return; }
      if (!m) return;
      var card = a.closest('[data-product-card]');
      if (!card || !grid.contains(card)) card = cardFor(decodeURIComponent(m[1]), '');
      savedByClick = true;
      store(snapshot(card));
    });

    // Leaving any other way (Back to the previous page, reload): keep the place too, so Forward
    // and reload do not drop to the top now that the browser's own restoration is off.
    window.addEventListener('pagehide', function () {
      if (savedByClick || restoring) return;
      if (window.scrollY > 200) store(snapshot(null)); else unstore();
    });

    function navType() {
      try {
        var nav = performance.getEntriesByType('navigation')[0];
        if (nav && nav.type) return nav.type;
      } catch (e) {}
      return (performance.navigation && performance.navigation.type === 2) ? 'back_forward' : 'navigate';
    }

    function loadTo(n) {
      if (loaded >= n || !nextUrl) return Promise.resolve();
      return loadNext(false).then(function (ok) { return ok ? loadTo(n) : undefined; });
    }

    function scrollBack(rec) {
      var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      var y = rec.y || 0;
      var card = rec.handle ? cardFor(rec.handle, rec.variant) : null;
      if (card && typeof rec.off === 'number') {
        y = card.getBoundingClientRect().top + window.scrollY - rec.off;
      }
      y = Math.min(Math.max(0, Math.round(y)), max);   // product set changed: fall back, clamped
      var root = document.documentElement, prev = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';   // the site sets smooth; a restore must jump
      window.scrollTo(0, y);
      root.style.scrollBehavior = prev;
    }

    function restore(fromCache) {
      var rec = recall();
      if (!rec || restoring) return;
      var t = navType();
      if (!fromCache && t !== 'back_forward' && t !== 'reload') { unstore(); return; }
      restoring = true;
      var done = function () {
        scrollBack(rec);
        unstore();
        savedByClick = false;
        restoring = false;
        // Late layout (fonts, images above the card) can nudge it; correct once if the shopper has not moved.
        if (document.readyState !== 'complete') {
          var at = window.scrollY;
          window.addEventListener('load', function () { if (Math.abs(window.scrollY - at) < 4) scrollBack(rec); }, { once: true });
        }
      };
      loadTo(rec.pages).then(done, done);
    }

    // Browsers restore their own scroll on Back/Forward before our pages exist. Switch that off
    // on this page only (the history entry remembers it) and do it ourselves.
    try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}
    restore(false);
    window.addEventListener('pageshow', function (e) { if (e.persisted) restore(true); });
  }

  /* ------------------------------------------------------------ Back link */

  // The product page "Back" link is a real <a href> (the collection) for
  // crawlers and no-JS. When the shopper came from another page on this site,
  // send them back there instead, scroll position and filters intact.
  function initBackLink() {
    var link = document.querySelector('[data-back-link]');
    if (!link) return;
    var ref = document.referrer;
    var same = false;
    try {
      var u = new URL(ref);
      same = u.origin === location.origin && u.pathname !== location.pathname;
    } catch (e) { same = false; }
    if (!same || window.history.length <= 1) return;
    link.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      window.history.back();
    });
  }

  /* ------------------------------------------ Password page reveal toggle */

  function initPasswordToggle() {
    var toggle = document.querySelector('[data-password-toggle]');
    var panel = document.querySelector('[data-password-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      toggle.hidden = true;
      var input = panel.querySelector('input');
      if (input) input.focus();
    });
  }

  /* ------------------------------------------- Collection filters + sort */

  // Plain GET form (works without JS). Here: submit on change, drop empty
  // price fields so the URL stays clean, and close other open filter panels.
  function initCollectionFilters() {
    var form = document.querySelector('[data-filters]');
    if (!form) return;
    var groups = form.querySelectorAll('.filters__group');

    function submit() {
      var nums = form.querySelectorAll('input[type="number"]');
      // Price From above To: swap them rather than return an empty grid.
      if (nums.length === 2 && nums[0].value !== '' && nums[1].value !== '' && parseFloat(nums[0].value) > parseFloat(nums[1].value)) {
        var lo = nums[1].value;
        nums[1].value = nums[0].value;
        nums[0].value = lo;
      }
      nums.forEach(function (input) {
        input.disabled = input.value === '';
      });
      form.submit();
    }

    form.addEventListener('change', function (e) {
      if (e.target.type === 'number') return;
      submit();
    });
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); submit(); }
      });
      input.addEventListener('blur', function () {
        if (input.value !== input.defaultValue) submit();
      });
    });

    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        groups.forEach(function (other) { if (other !== group) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!form.contains(e.target)) groups.forEach(function (g) { g.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      groups.forEach(function (g) {
        if (g.open) { g.open = false; g.querySelector('summary').focus(); }
      });
    });
  }

  /* ------------------------------------------------------ Card swatches */

  // Colour chips under a product card. Clicking / tapping one selects that
  // colour: the card photo becomes that colour's photo, the chip is marked
  // pressed and the card link points at ?variant=<id> for it. Hover and
  // keyboard focus only preload the photo, so nothing changes until chosen.
  // Safe to call again on new cards (Load more): each card binds once.
  function initCardSwatches(scope) {
    (scope || document).querySelectorAll('[data-product-card]').forEach(function (card) {
      if (card.__pfdSwatches) return;
      var swatches = card.querySelectorAll('.card-swatch');
      var img = card.querySelector('.product-card__img:not(.product-card__img--alt)');
      var link = card.querySelector('.product-card__link');
      if (!swatches.length || !img || !link) return;
      card.__pfdSwatches = true;
      var alt = card.querySelector('.product-card__img--alt');
      var orig = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), url: link.getAttribute('href'),
        altSrc: alt && alt.getAttribute('src'), altSrcset: alt && alt.getAttribute('srcset') };
      var initial = card.querySelector('.card-swatch.is-selected');
      var preloaded = {};

      function preload(sw) {
        if (sw.dataset.altSrc && !preloaded[sw.dataset.altSrc]) {
          preloaded[sw.dataset.altSrc] = true;
          var preAlt = new Image();
          if (sw.dataset.altSrcset) { preAlt.srcset = sw.dataset.altSrcset; if (img.sizes) preAlt.sizes = img.sizes; }
          preAlt.src = sw.dataset.altSrc;
        }
        if (!sw.dataset.src || preloaded[sw.dataset.src]) return;
        preloaded[sw.dataset.src] = true;
        var pre = new Image();
        if (sw.dataset.srcset) {
          pre.srcset = sw.dataset.srcset;
          if (img.sizes) pre.sizes = img.sizes;
        }
        pre.src = sw.dataset.src;
      }

      function select(sw) {
        swatches.forEach(function (s) {
          var on = s === sw;
          s.classList.toggle('is-selected', on);
          s.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var restore = sw === initial;
        if (restore) {
          img.setAttribute('src', orig.src);
          if (orig.srcset) img.setAttribute('srcset', orig.srcset);
        } else if (sw.dataset.src) {
          if (sw.dataset.srcset) img.setAttribute('srcset', sw.dataset.srcset);
          else img.removeAttribute('srcset');
          img.setAttribute('src', sw.dataset.src);
        }
        link.setAttribute('href', sw.dataset.url || orig.url);
        // The hover image follows the colour too (its back or front, or the model
        // shot), so the hover swap keeps working after a pick.
        var hasAlt = false;
        if (alt) {
          if (restore) {
            if (orig.altSrcset) alt.setAttribute('srcset', orig.altSrcset);
            if (orig.altSrc) alt.setAttribute('src', orig.altSrc);
            hasAlt = true;
          } else if (sw.dataset.altSrc) {
            if (sw.dataset.altSrcset) alt.setAttribute('srcset', sw.dataset.altSrcset);
            else alt.removeAttribute('srcset');
            alt.setAttribute('src', sw.dataset.altSrc);
            alt.loading = 'eager';
            hasAlt = true;
          }
        }
        card.classList.toggle('is-swatch-swapped', !restore && !!sw.dataset.src && !hasAlt);
        card.dispatchEvent(new CustomEvent('pfd:swatch', { detail: { value: sw.getAttribute('aria-label') } }));
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('mouseenter', function () { preload(sw); });
        sw.addEventListener('focus', function () { preload(sw); });
        sw.addEventListener('touchstart', function () { preload(sw); }, { passive: true });
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          select(sw);
        });
      });

      // A colour filter is on (the filter bar lists the active colours): show that colour. Cards
      // the server already rendered in it (Core rotation) are left alone.
      var want = activeColours();
      if (want.length) {
        var cur = card.querySelector('.card-swatch.is-selected');
        var curOk = cur && want.indexOf((cur.getAttribute('aria-label') || '').toLowerCase()) > -1;
        if (!curOk) {
          for (var i = 0; i < swatches.length; i++) {
            if (want.indexOf((swatches[i].getAttribute('aria-label') || '').toLowerCase()) > -1) { select(swatches[i]); break; }
          }
        }
      }
    });
  }

  // Colours ticked in the collection filter bar, lower-cased (data-active-colours="Black|Sand|").
  function activeColours() {
    var f = document.querySelector('[data-filters][data-active-colours]');
    var raw = f ? f.getAttribute('data-active-colours') : '';
    return raw ? raw.toLowerCase().split('|').filter(Boolean) : [];
  }

  /* --------------------------------------------------- Card touch swap */

  // Touch screens never hover, so the on-model photo would stay hidden. A
  // horizontal swipe on the card image toggles the second photo (two dots show
  // it exists). Taps still follow the link; a swipe never does.
  function initCardTouchSwap() {
    if (!window.matchMedia || !window.matchMedia('(hover: none)').matches) return;
    var start = null, swallow = 0;

    function prep(card) {
      if (card.__pfdTouchSwap) return;
      var media = card.querySelector('.product-card__media');
      if (!media || !media.querySelector('.product-card__img--alt')) return;
      card.__pfdTouchSwap = true;
      card.classList.add('has-alt');
      var dots = document.createElement('span');
      dots.className = 'product-card__dots';
      dots.setAttribute('aria-hidden', 'true');
      dots.appendChild(document.createElement('span'));
      dots.appendChild(document.createElement('span'));
      media.appendChild(dots);
    }
    function scan() { document.querySelectorAll('[data-product-card]').forEach(prep); }
    scan();
    if ('MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; scan(); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('touchstart', function (e) {
      var media = e.target.closest && e.target.closest('.product-card.has-alt .product-card__media');
      var t = e.touches[0];
      start = media && e.touches.length === 1 ? { media: media, x: t.clientX, y: t.clientY } : null;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      if (!start) return;
      var t = e.changedTouches[0], dx = t.clientX - start.x, dy = t.clientY - start.y;
      var card = start.media.closest('.product-card');
      start = null;
      if (Math.abs(dx) < 30 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      card.classList.toggle('is-alt-shown', dx < 0);
      swallow = Date.now();
    }, { passive: true });

    document.addEventListener('click', function (e) {
      if (Date.now() - swallow < 400 && e.target.closest && e.target.closest('.product-card__media')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  /* ----------------------------------------------------------- Quick add */

  // Two pieces, one closure (they share the product cache and cart calls):
  //  1. Card hover bar: sizes for the card's selected colour (click = add to
  //     cart) plus a "Quick view" button. Built lazily on first hover/focus.
  //  2. Quick view drawer: slides in from the right with the product's
  //     photos of the chosen colour, Color and Size pickers and Add to
  //     cart. Description, specs and size guide stay on the product page.
  // Everything is delegated, so cards added later (Load more) just work.
  function initQuickAdd() {
    if (typeof HTMLDialogElement === 'undefined') return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var productCache = {};
    var dlg = null, els = {}, state = null, lastTrigger = null, hexMap = {};

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function sized(src, w) {
      if (!src) return '';
      try {
        var u = new URL(src, location.href);
        u.searchParams.set('width', w);
        return u.toString();
      } catch (e) { return src; }
    }

    function optionLabel(name) { return /^colou?r$/i.test(name) ? 'Color' : name; }

    function fetchProduct(handle) {
      if (productCache[handle]) return Promise.resolve(productCache[handle]);
      return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('fetch'); return r.json(); })
        .then(function (p) { productCache[handle] = p; return p; });
    }

    function optionNames(p) { return p.options.map(function (o) { return typeof o === 'string' ? o : o.name; }); }

    function optionPositions(p) {
      var names = optionNames(p), colourPos = -1, sizePos = -1;
      names.forEach(function (n, i) {
        if (/^colou?r$/i.test(n)) colourPos = i;
        else if (/^size$/i.test(n)) sizePos = i;
      });
      return { names: names, colourPos: colourPos, sizePos: sizePos };
    }

    function addToCart(id, qty, returnTo) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty || 1 })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart.');
          return j;
        });
      }).then(function (j) {
        /* the cart drawer (initCartDrawer) opens and the header count updates */
        document.dispatchEvent(new CustomEvent('pfd:cart-add', { detail: { returnTo: returnTo || null } }));
        return j;
      });
    }

    /* ------------------------------------------------ Card hover bar */

    function cardColour(card, p, pos) {
      var sel = card.querySelector('.card-swatch.is-selected');
      if (sel) return sel.getAttribute('aria-label');
      return pos.colourPos >= 0 ? p.variants[0].options[pos.colourPos] : null;
    }

    // Two-step buy row: sizes are selectors, "Add to cart" (right) adds the
    // card's colour + chosen size. One-size products enable it straight away.
    function buildBar(card, p) {
      var quick = card.querySelector('[data-card-quick]');
      var box = card.querySelector('[data-card-sizes]');
      var addBtn = card.querySelector('[data-card-add]');
      var live = card.querySelector('[data-card-status]');
      if (!quick || !box || !addBtn) return;
      var pos = optionPositions(p);
      var colour = cardColour(card, p, pos);
      var fixed = quick.getAttribute('data-variant');
      var chosen = card.__pfdSize || null;
      var current = null;
      box.textContent = '';

      function say(msg) { if (live) live.textContent = msg; }
      function byColour(v) { return pos.colourPos < 0 || !colour || v.options[pos.colourPos] === colour; }
      function setAdd(variant, label) {
        current = variant && variant.available ? variant : null;
        addBtn.disabled = !current;
        addBtn.textContent = label;
        addBtn.setAttribute('aria-label', current ? 'Add ' + p.title + (chosen ? ', size ' + chosen : '') + ' to cart' : label);
      }

      var seen = [];
      if (pos.sizePos >= 0 && !fixed) {
        p.variants.forEach(function (v) { if (seen.indexOf(v.options[pos.sizePos]) < 0) seen.push(v.options[pos.sizePos]); });
      }

      if (seen.length > 1) {
        var vFor = function (val) {
          return p.variants.filter(function (x) { return byColour(x) && x.options[pos.sizePos] === val; })[0];
        };
        /* a size that is not available in this colour is dropped */
        if (chosen && !(vFor(chosen) && vFor(chosen).available)) chosen = null;
        card.__pfdSize = chosen;
        box.setAttribute('role', 'group');
        box.setAttribute('aria-label', 'Choose a size');
        seen.forEach(function (val) {
          var v = vFor(val);
          var sold = !v || !v.available;
          var b = el('button', 'card-quick__size mono', val);
          b.type = 'button';
          b.setAttribute('aria-label', 'Size ' + val + (sold ? ', sold out' : ''));
          b.setAttribute('aria-pressed', chosen === val ? 'true' : 'false');
          if (chosen === val) b.classList.add('is-selected');
          if (sold) {
            b.disabled = true;
            b.classList.add('is-soldout');
            b.title = 'Sold out';
          } else {
            b.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              chosen = val;
              card.__pfdSize = val;
              box.querySelectorAll('.card-quick__size').forEach(function (s) {
                var on = s === b;
                s.classList.toggle('is-selected', on);
                s.setAttribute('aria-pressed', on ? 'true' : 'false');
              });
              setAdd(v, 'Add to cart');
            });
          }
          box.appendChild(b);
        });
        var cv = chosen ? vFor(chosen) : null;
        setAdd(cv, 'Add to cart');
        if (!cv) addBtn.disabled = true;
      } else {
        var v1 = null;
        if (fixed) v1 = p.variants.filter(function (x) { return String(x.id) === fixed; })[0];
        if (!v1) v1 = p.variants.filter(function (x) { return byColour(x) && x.available; })[0] || p.variants.filter(byColour)[0];
        setAdd(v1, v1 && v1.available ? 'Add to cart' : 'Sold out');
      }

      if (!addBtn.__pfdBound) {
        addBtn.__pfdBound = true;
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var variant = addBtn.__pfdVariant && addBtn.__pfdVariant();
          if (!variant || addBtn.disabled) return;
          var label = addBtn.textContent;
          addBtn.disabled = true;
          addBtn.textContent = 'Adding...';
          addToCart(variant.id, 1, card.querySelector('.card-quick__view') || card.querySelector('.card-quick__btn')).then(function () {
            say('Added ' + p.title + ' to your cart.');
          }).catch(function (err) {
            say(err.message || 'Could not add to cart.');
          }).then(function () {
            addBtn.textContent = label;
            addBtn.disabled = false;
          });
        });
      }
      addBtn.__pfdVariant = function () { return current; };
    }

    function ensureBar(card) {
      if (card.__pfdBar) return;
      var quick = card.querySelector('[data-card-quick]');
      if (!quick) return;
      card.__pfdBar = true;
      fetchProduct(quick.getAttribute('data-handle')).then(function (p) {
        buildBar(card, p);
        card.addEventListener('pfd:swatch', function () { buildBar(card, p); });
      }).catch(function () { card.__pfdBar = false; });
    }

    function cardOf(e) { return e.target.closest && e.target.closest('[data-product-card]'); }
    document.addEventListener('mouseover', function (e) { var c = cardOf(e); if (c) ensureBar(c); });
    document.addEventListener('focusin', function (e) { var c = cardOf(e); if (c) ensureBar(c); });
    document.addEventListener('touchstart', function (e) { var c = cardOf(e); if (c) ensureBar(c); }, { passive: true });

    /* ------------------------------------------------------ Drawer */

    function build() {
      dlg = el('dialog', 'quick-add');
      dlg.setAttribute('aria-labelledby', 'quick-add-title');
      var panel = el('div', 'quick-add__panel');

      var head = el('div', 'quick-add__head');
      head.appendChild(el('span', 'quick-add__eyebrow mono', 'Quick view'));
      var close = el('button', 'quick-add__close mono', 'Close ');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close quick view');
      close.appendChild(el('span', null, '›'));
      close.lastChild.setAttribute('aria-hidden', 'true');
      head.appendChild(close);

      var body = el('div', 'quick-add__body');
      els.title = el('h2', 'quick-add__title');
      els.title.id = 'quick-add-title';
      els.price = el('div', 'product__price');

      els.gallery = el('div', 'quick-add__gallery');
      els.track = el('div', 'quick-add__track');
      els.track.tabIndex = 0;
      els.track.setAttribute('role', 'group');
      els.track.setAttribute('aria-label', 'Product photos');
      els.prev = el('button', 'quick-add__nav quick-add__nav--prev', '←');
      els.next = el('button', 'quick-add__nav quick-add__nav--next', '→');
      els.prev.type = els.next.type = 'button';
      els.prev.setAttribute('aria-label', 'Previous photo');
      els.next.setAttribute('aria-label', 'Next photo');
      var meta = el('div', 'quick-add__meta');
      els.counter = el('span', 'quick-add__counter mono');
      els.counter.setAttribute('aria-live', 'polite');
      var line = el('span', 'quick-add__progress');
      els.bar = el('span');
      line.appendChild(els.bar);
      meta.appendChild(els.counter);
      meta.appendChild(line);
      els.gallery.appendChild(els.track);
      els.gallery.appendChild(els.prev);
      els.gallery.appendChild(els.next);
      els.gallery.appendChild(meta);

      els.options = el('div', 'quick-add__options');
      els.btn = el('button', 'btn btn--primary product__submit quick-add__submit', 'Select a size');
      els.btn.type = 'button';
      els.status = el('p', 'quick-add__status mono');
      els.status.setAttribute('role', 'status');
      els.status.setAttribute('aria-live', 'polite');
      var links = el('div', 'quick-add__links');
      els.cart = el('a', 'quick-add__link mono link-underline', 'View cart');
      els.cart.href = root + 'cart';
      els.cart.hidden = true;
      els.details = el('a', 'quick-add__link mono link-underline', 'Full details');
      links.appendChild(els.cart);
      links.appendChild(els.details);

      els.gender = el('span', 'product-badge quick-add__gender mono', 'Women\u2019s');
      els.gender.hidden = true;
      body.appendChild(els.gender);
      body.appendChild(els.title);
      body.appendChild(els.price);
      body.appendChild(els.gallery);
      body.appendChild(els.options);
      /* Buy block: stays pinned to the bottom of the drawer. */
      var buy = el('div', 'quick-add__buy');
      var foot = el('div', 'quick-add__foot');
      foot.appendChild(links);
      buy.appendChild(els.btn);
      buy.appendChild(els.status);
      buy.appendChild(foot);
      body.appendChild(buy);
      panel.appendChild(head);
      panel.appendChild(body);
      dlg.appendChild(panel);
      document.body.appendChild(dlg);

      close.addEventListener('click', shut);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); shut(); });
      dlg.addEventListener('close', function () {
        dlg.classList.remove('is-in');
        document.documentElement.classList.remove('quick-add-open');
        if (lastTrigger) lastTrigger.focus();
      });
      els.btn.addEventListener('click', add);
      els.prev.addEventListener('click', function () { slide(-1); });
      els.next.addEventListener('click', function () { slide(1); });
      els.track.addEventListener('scroll', function () {
        if (els.raf) return;
        els.raf = requestAnimationFrame(function () { els.raf = 0; counter(); });
      }, { passive: true });
      els.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); slide(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); slide(-1); }
      });
    }

    function shut() {
      if (!dlg || !dlg.open) return;
      if (reduce.matches) { dlg.close(); return; }
      dlg.classList.remove('is-in');
      var done = false;
      function fin() { if (done) return; done = true; if (dlg.open) dlg.close(); }
      dlg.addEventListener('transitionend', function te(e) {
        if (e.target !== dlg) return;
        dlg.removeEventListener('transitionend', te);
        fin();
      });
      setTimeout(fin, 400);
    }

    function slideCount() { return els.track.children.length; }
    function slideIndex() {
      var w = els.track.clientWidth || 1;
      return Math.max(0, Math.min(slideCount() - 1, Math.round(els.track.scrollLeft / w)));
    }
    function counter() {
      var n = slideCount(), i = slideIndex();
      els.counter.textContent = n ? (i + 1) + ' / ' + n : '';
      els.bar.style.width = n ? ((i + 1) / n * 100) + '%' : '0';
      els.prev.disabled = i <= 0;
      els.next.disabled = i >= n - 1;
      els.gallery.classList.toggle('is-single', n < 2);
    }
    function slide(dir) {
      var i = Math.max(0, Math.min(slideCount() - 1, slideIndex() + dir));
      els.track.scrollTo({ left: i * els.track.clientWidth, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    function stemOf(src) {
      var f = (src || '').split('?')[0].split('/').pop().toLowerCase().replace(/^\d\d-/, '');
      var parts = f.split('_');
      if (parts.length >= 3 && parseInt(parts[0], 10) > 0 && parts[1].length === 6) return parts[0] + '_' + parts[1];
      var views = ['-chest-close-up', '-sleeve-angle', '-front', '-back', '-folded'];
      for (var i = 0; i < views.length; i++) { if (f.indexOf(views[i]) >= 0) return f.split(views[i])[0]; }
      return '';
    }

    /* Back-first rule (Patrick 2026-10-06): a product with a back design leads with the
       back view in the selected colour; the colour's front (the variant image) comes next.
       Same rule as snippets/product-card.liquid. Back view = file name -back, _111 or
       _486 (Apliiq back), or alt "back" that is not an on-model shot. When the product
       has no product-shot back (Bloom hoodies, 2026-10-07: renders replaced by model
       backs), the colour's on-model back ("on model, back artwork") leads instead. */
    function fileOf(m) { return ((m && m.src) || '').split('?')[0].split('/').pop().toLowerCase(); }
    function isModelBack(m) {
      var a = String(m.alt || '').toLowerCase();
      return /on model/.test(a) && /back artwork/.test(a) && !/his and hers/.test(a);
    }
    function isBackView(m) {
      var f = fileOf(m), a = String(m.alt || '').toLowerCase();
      if (/on model|worn/.test(a)) return false;
      return /-back|_(111|486)(\.|-|_|$)/.test(f) || /(^|[ ,])back( |$|,)/.test(a);
    }
    function isBackDetail(m) { return /detail|close-up/.test(fileOf(m)) || /detail|close-up/.test(String(m.alt || '').toLowerCase()); }
    function hasBackDesign(p, all) {
      var tags = p.tags || [];
      if (typeof tags === 'string') tags = tags.split(',').map(function (t) { return t.trim(); });
      if (tags.indexOf('feature:full-back') >= 0 || tags.indexOf('car-artwork') >= 0) return true;
      return all.some(function (m) { return /back-detail/.test(fileOf(m)) || /back print/i.test(String(m.alt || '')); });
    }
    function backFirst(list, all, v) {
      if (list.length < 2 || !hasBackDesign(state.product, all)) return list;
      var colour = v && state.colourPos >= 0 ? String(v.options[state.colourPos] || '').toLowerCase() : '';
      var backs = list.filter(isBackView);
      // The colour subset is matched on file name, and ZD8 fronts share Sakura file
      // names, so its backs fall outside it: look across all media, this colour only.
      function inColour(m) { return !colour || String(m.alt || '').toLowerCase().indexOf(colour) >= 0; }
      if (!backs.length) backs = all.filter(function (m) { return isBackView(m) && inColour(m); });
      if (!backs.length) backs = all.filter(function (m) { return isModelBack(m) && inColour(m); });
      if (!backs.length) return list;
      var full = backs.filter(function (m) { return !isBackDetail(m); });
      var pool = full.length ? full : backs;
      var lead = pool[0];
      if (colour) {
        for (var i = 0; i < pool.length; i++) {
          if (String(pool[i].alt || '').toLowerCase().indexOf(colour) >= 0) { lead = pool[i]; break; }
        }
      }
      return [lead].concat(list.filter(function (m) { return m !== lead; }));
    }

    function photosFor(v) {
      var p = state.product;
      var all = (p.media || []).filter(function (m) { return !m.media_type || m.media_type === 'image'; });
      if (!all.length) return state.fallbackImg ? [{ src: state.fallbackImg, alt: p.title }] : [];
      var feat = v && v.featured_image && v.featured_image.src;
      var st = stemOf(feat);
      if (st) {
        var sub = all.filter(function (m) { return m.src.toLowerCase().indexOf(st) >= 0; });
        if (sub.length >= 2) {
          sub.sort(function (a, b) { return (a.src === feat ? 0 : 1) - (b.src === feat ? 0 : 1); });
          return backFirst(sub, all, v);
        }
      }
      return backFirst(all, all, v);
    }

    function renderPhotos(v) {
      var list = photosFor(v);
      var key = list.map(function (m) { return m.src; }).join('|');
      if (state.photoKey === key) return;
      state.photoKey = key;
      els.track.textContent = '';
      list.forEach(function (m, i) {
        var s = el('div', 'quick-add__slide');
        var img = el('img', 'quick-add__img');
        img.src = sized(m.src, 900);
        img.srcset = sized(m.src, 500) + ' 500w, ' + sized(m.src, 900) + ' 900w, ' + sized(m.src, 1200) + ' 1200w';
        img.sizes = '(min-width: 500px) 500px, 100vw';
        img.alt = m.alt || state.product.title;
        img.width = 900;
        img.height = 1125;
        /* 4:5 frame, cover; neck-label and sleeve-detail shots stay whole. */
        if (/neck|sleeve detail/i.test(String(img.alt).replace(/crewneck/ig, ''))) img.classList.add('is-contain');
        if (i > 0) img.loading = 'lazy';
        s.appendChild(img);
        els.track.appendChild(s);
      });
      els.track.scrollLeft = 0;
      counter();
    }

    function findVariant(vals) {
      var list = state.product.variants;
      for (var i = 0; i < list.length; i++) {
        var v = list[i], ok = true;
        for (var j = 0; j < vals.length; j++) { if (vals[j] != null && v.options[j] !== vals[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function fullVariant() {
      if (state.values.some(function (x) { return x == null; })) return null;
      return findVariant(state.values);
    }

    /* a value is sold out when the variant it would give is missing/unavailable */
    function soldOut(pos, value) {
      var t = state.values.slice();
      t[pos] = value;
      var any = t.map(function (x, k) { return x == null ? null : x; });
      return !state.product.variants.some(function (v) {
        if (!v.available) return false;
        for (var j = 0; j < any.length; j++) { if (any[j] != null && v.options[j] !== any[j]) return false; }
        return true;
      });
    }

    function firstMissing() {
      for (var i = 0; i < state.values.length; i++) { if (state.values[i] == null) return i; }
      return -1;
    }

    /* Quick view is for one decision (colour, size, add). Description, specs
       and the size guide live on the product page ("Full details"). */
    function renderInfo() {}

    function render() {
      var p = state.product;
      var v = fullVariant();
      var pv = v || findVariant(state.values) || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      els.title.textContent = p.title;
      var tags = p.tags || [];
      els.gender.hidden = !((String(p.handle).indexOf('womens-') === 0) || (tags.indexOf('Women') >= 0 && tags.indexOf('Men') < 0));
      els.details.href = root + 'products/' + p.handle + (v ? '?variant=' + v.id : '');
      renderPhotos(pv);

      els.price.textContent = '';
      if (pv.compare_at_price && pv.compare_at_price > pv.price) {
        els.price.appendChild(el('span', 'product__price-sale mono', 'Sale'));
        els.price.appendChild(el('s', 'product__price-compare', money(pv.compare_at_price)));
      }
      els.price.appendChild(el('span', 'product__price-current', money(pv.price)));

      els.options.textContent = '';
      if (p.variants.length > 1) {
        state.names.forEach(function (name, pos) {
          var values = [];
          p.variants.forEach(function (x) { if (values.indexOf(x.options[pos]) < 0) values.push(x.options[pos]); });
          if (values.length < 2) return;
          var isColour = pos === state.colourPos;
          var set = el('fieldset', 'product-option');
          var legend = el('legend', 'capture__label');
          legend.appendChild(el('span', null, optionLabel(name)));
          if (isColour && state.values[pos]) legend.appendChild(el('span', 'quick-add__chosen', state.values[pos]));
          set.appendChild(legend);
          var row = el('div', 'product-option__values');
          var asSwatch = isColour && values.every(function (val) { return hexMap[val.toLowerCase()]; });
          values.forEach(function (val) {
            var sold = soldOut(pos, val);
            var on = state.values[pos] === val;
            var b = el('button', asSwatch ? 'card-swatch quick-add__swatch' : 'product-option__value', asSwatch ? '' : val);
            b.type = 'button';
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
            b.setAttribute('data-qa-pos', pos);
            b.setAttribute('data-qa-value', val);
            if (on) b.classList.add('is-selected');
            if (sold) b.classList.add('is-soldout');
            if (asSwatch) {
              b.style.setProperty('--swatch', hexMap[val.toLowerCase()]);
              b.setAttribute('aria-label', val + (sold ? ', Sold out' : ''));
              b.title = val + (sold ? ' (sold out)' : '');
            } else if (sold) {
              b.appendChild(el('span', 'visually-hidden', ', Sold out'));
            }
            b.addEventListener('click', function () { choose(pos, val); });
            row.appendChild(b);
          });
          set.appendChild(row);
          els.options.appendChild(set);
        });
      }

      var miss = firstMissing();
      if (miss >= 0) {
        els.btn.disabled = true;
        els.btn.textContent = 'Select a ' + optionLabel(state.names[miss]).toLowerCase();
      } else {
        els.btn.disabled = !(v && v.available);
        els.btn.textContent = v && v.available ? 'Add to cart' : 'Sold out';
      }
    }

    function choose(pos, val) {
      state.values[pos] = val;
      /* a colour change keeps the size if that size exists in the new colour */
      if (pos === state.colourPos) {
        state.values.forEach(function (cur, k) {
          if (k !== pos && cur != null && !findVariant(state.values.map(function (x, j) { return j === k ? cur : (j === pos ? val : x); }))) state.values[k] = null;
        });
      }
      els.status.textContent = '';
      els.cart.hidden = true;
      render();
      var again = els.options.querySelector('[data-qa-pos="' + pos + '"][data-qa-value="' + String(val).replace(/"/g, '\\"') + '"]');
      if (again) again.focus();
    }

    function add() {
      var v = fullVariant();
      if (!v || !v.available) return;
      els.btn.disabled = true;
      els.btn.textContent = 'Adding...';
      addToCart(v.id, 1, lastTrigger).then(function () {
        /* Quick view gives way to the cart drawer */
        els.btn.disabled = false;
        render();
      }).catch(function (err) {
        els.status.textContent = err.message || 'Could not add to cart.';
        render();
      });
    }

    function open(btn) {
      var card = btn.closest('[data-product-card]');
      lastTrigger = btn;
      hexMap = {};
      if (card) {
        card.querySelectorAll('.card-swatches .card-swatch').forEach(function (s) {
          hexMap[(s.getAttribute('aria-label') || '').toLowerCase()] = s.style.getPropertyValue('--swatch');
        });
      }
      var handle = btn.getAttribute('data-handle');
      btn.setAttribute('aria-busy', 'true');
      fetchProduct(handle).then(function (p) {
        btn.removeAttribute('aria-busy');
        if (!dlg) build();
        var pos = optionPositions(p);
        var wanted = btn.getAttribute('data-variant');
        var start = null;
        p.variants.forEach(function (v) { if (String(v.id) === wanted) start = v; });
        var values = pos.names.map(function () { return null; });
        // The swatch the shopper picked on the card wins over the button's default variant.
        var picked = card && card.querySelector('.card-swatches .card-swatch.is-selected');
        var pickedColour = picked && picked.getAttribute('aria-label');
        if (pickedColour) pickedColour = pickedColour.replace(/, Sold out$/, '');
        if (start) {
          values = start.options.slice();
          if (pos.colourPos >= 0 && pickedColour && pickedColour !== values[pos.colourPos]) {
            values = pos.names.map(function () { return null; });
            values[pos.colourPos] = pickedColour;
          }
        } else if (p.variants.length === 1) {
          values = p.variants[0].options.slice();
        } else if (pos.colourPos >= 0) {
          var sel = card && card.querySelector('.card-swatches .card-swatch.is-selected');
          var colour = sel && sel.getAttribute('aria-label');
          if (!colour) {
            var fa = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
            colour = fa.options[pos.colourPos];
          }
          values[pos.colourPos] = colour;
        }
        /* an option with a single value is never a choice */
        pos.names.forEach(function (n, i) {
          var vs = [];
          p.variants.forEach(function (x) { if (vs.indexOf(x.options[i]) < 0) vs.push(x.options[i]); });
          if (vs.length === 1) values[i] = vs[0];
        });
        var fi = p.featured_image;
        state = {
          product: p, values: values, names: pos.names, colourPos: pos.colourPos, sizePos: pos.sizePos,
          fallbackImg: typeof fi === 'string' ? fi : (fi && fi.src) || '', page: null, photoKey: ''
        };
        els.status.textContent = '';
        els.cart.hidden = true;
        renderInfo();
        render();
        document.documentElement.classList.add('quick-add-open');
        if (!dlg.open) dlg.showModal();
        if (reduce.matches) dlg.classList.add('is-in');
        else requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-in'); }); });
        els.track.scrollLeft = 0;
        counter();
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        window.location.href = root + 'products/' + handle;
      });
    }

    document.addEventListener('pfd:cart-add', function () {
      if (dlg && dlg.open) {
        lastTrigger = null;
        dlg.classList.remove('is-in');
        dlg.close();
      }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      open(btn);
    });
  }

  /* --------------------------------------------------------- Cart drawer */

  // Slides in from the right (same look as Quick view) after anything is added
  // to the cart, and from the header bag icon. Listens for `pfd:cart-add`
  // (fired by the card size bar, Quick view and the product page form).
  // The bag link keeps href=/cart, so it still works without JavaScript.
  function initCartDrawer() {
    if (typeof HTMLDialogElement === 'undefined' || !window.fetch) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var threshold = (window.PFD_CART_CONFIG && window.PFD_CART_CONFIG.freeShippingCents) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var dlg = null, els = {}, returnTo = null, busy = false;

    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }

    function money(cents) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
      } catch (e) { return '$' + (cents / 100).toFixed(2); }
    }

    function sized(src, w) {
      if (!src) return '';
      try {
        var u = new URL(src, location.href);
        u.searchParams.set('width', w);
        return u.toString();
      } catch (e) { return src; }
    }

    function setCount(n) {
      document.querySelectorAll('[data-cart-open]').forEach(function (link) {
        var b = link.querySelector('.cart-count');
        if (n > 0) {
          if (!b) { b = el('span', 'cart-count'); b.setAttribute('aria-hidden', 'true'); link.appendChild(b); }
          b.textContent = n;
        } else if (b) {
          b.remove();
        }
        var base = link.getAttribute('data-cart-label') || 'Cart';
        link.setAttribute('aria-label', n > 0 ? base + ' (' + n + (n === 1 ? ' item)' : ' items)') : base);
      });
    }

    function getCart() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }

    function build() {
      dlg = el('dialog', 'quick-add cart-drawer');
      dlg.setAttribute('aria-labelledby', 'cart-drawer-title');
      var panel = el('div', 'quick-add__panel');
      var head = el('div', 'quick-add__head');
      els.title = el('span', 'quick-add__eyebrow mono', 'Your cart');
      els.title.id = 'cart-drawer-title';
      var close = el('button', 'quick-add__close mono', 'Close ');
      close.type = 'button';
      close.setAttribute('aria-label', 'Close cart');
      var chev = el('span', null, '›');
      chev.setAttribute('aria-hidden', 'true');
      close.appendChild(chev);
      head.appendChild(els.title);
      head.appendChild(close);

      els.body = el('div', 'quick-add__body cart-drawer__body');
      els.foot = el('div', 'cart-drawer__foot');
      panel.appendChild(head);
      panel.appendChild(els.body);
      panel.appendChild(els.foot);
      dlg.appendChild(panel);
      document.body.appendChild(dlg);

      close.addEventListener('click', shut);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) shut(); });
      dlg.addEventListener('cancel', function (e) { e.preventDefault(); shut(); });
      dlg.addEventListener('close', function () {
        dlg.classList.remove('is-in');
        document.documentElement.classList.remove('cart-drawer-open');
        if (returnTo && returnTo.isConnected && typeof returnTo.focus === 'function') returnTo.focus();
      });
    }

    function shut() {
      if (!dlg || !dlg.open) return;
      if (reduce.matches) { dlg.close(); return; }
      dlg.classList.remove('is-in');
      var done = false;
      function fin() { if (done) return; done = true; if (dlg.open) dlg.close(); }
      dlg.addEventListener('transitionend', function te(e) {
        if (e.target !== dlg) return;
        dlg.removeEventListener('transitionend', te);
        fin();
      });
      setTimeout(fin, 400);
    }

    function change(key, qty, focusSel) {
      if (busy) return;
      busy = true;
      els.body.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function (cart) {
          render(cart);
          setCount(cart.item_count);
          var f = focusSel && els.body.querySelector(focusSel);
          if (!f) f = els.body.querySelector('.cart-drawer__item button') || els.body.querySelector('a');
          if (f) f.focus();
        })
        .catch(function () {
          els.status.textContent = 'Could not update your cart. Please try again.';
        })
        .then(function () { busy = false; els.body.removeAttribute('aria-busy'); });
    }

    function render(cart) {
      var n = cart.item_count;
      els.title.textContent = 'Your cart (' + n + ')';
      els.body.textContent = '';
      els.foot.textContent = '';
      els.status = el('p', 'quick-add__status mono');
      els.status.setAttribute('role', 'status');
      els.status.setAttribute('aria-live', 'polite');

      if (!n) {
        var empty = el('div', 'cart-drawer__empty');
        empty.appendChild(el('p', 'cart-drawer__empty-text', 'Your cart is empty.'));
        var cta = el('a', 'btn btn--primary', 'Shop all');
        cta.href = root + 'collections/all';
        empty.appendChild(cta);
        els.body.appendChild(empty);
        els.body.appendChild(els.status);
        return;
      }

      if (threshold > 0) {
        var left = threshold - cart.total_price;
        var ship = el('div', 'cart-drawer__ship');
        var msg = el('p', 'cart-drawer__ship-msg mono', left > 0
          ? 'You’re ' + money(left) + ' away from free shipping'
          : 'You’ve unlocked free shipping');
        var line = el('span', 'quick-add__progress');
        var bar = el('span');
        bar.style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
        line.appendChild(bar);
        ship.appendChild(msg);
        ship.appendChild(line);
        els.body.appendChild(ship);
      }

      var list = el('ul', 'cart-drawer__list');
      list.setAttribute('role', 'list');
      cart.items.forEach(function (item) {
        var li = el('li', 'cart-drawer__item');
        var thumb = el('a', 'cart-drawer__thumb');
        thumb.href = item.url;
        thumb.tabIndex = -1;
        thumb.setAttribute('aria-hidden', 'true');
        if (item.image) {
          var im = el('img');
          im.src = sized(item.image, 200);
          im.alt = '';
          im.width = 100;
          im.height = 100;
          im.loading = 'lazy';
          thumb.appendChild(im);
        }
        var info = el('div', 'cart-drawer__info');
        var t = el('a', 'cart-drawer__name', item.product_title);
        t.href = item.url;
        info.appendChild(t);
        var opts = (item.options_with_values || []).filter(function (o) { return !/^title$/i.test(o.name); });
        if (opts.length) {
          info.appendChild(el('p', 'cart-drawer__variant mono', opts.map(function (o) {
            return (/^colou?r$/i.test(o.name) ? 'Color' : o.name) + ': ' + o.value;
          }).join(' / ')));
        }
        var row = el('div', 'cart-drawer__row');
        var qty = el('div', 'cart-drawer__qty');
        var minus = el('button', 'cart-drawer__step', '−');
        minus.type = 'button';
        minus.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
        minus.setAttribute('data-key', item.key);
        minus.setAttribute('data-act', 'dec');
        var num = el('span', 'cart-drawer__num mono', String(item.quantity));
        var plus = el('button', 'cart-drawer__step', '+');
        plus.type = 'button';
        plus.setAttribute('aria-label', 'Increase quantity of ' + item.product_title);
        plus.setAttribute('data-key', item.key);
        plus.setAttribute('data-act', 'inc');
        qty.appendChild(minus);
        qty.appendChild(num);
        qty.appendChild(plus);
        row.appendChild(qty);
        row.appendChild(el('span', 'cart-drawer__price', money(item.final_line_price)));
        info.appendChild(row);
        var rm = el('button', 'cart-drawer__remove mono link-underline', 'Remove');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Remove ' + item.product_title + ' from cart');
        rm.setAttribute('data-key', item.key);
        rm.setAttribute('data-act', 'rm');
        info.appendChild(rm);
        li.appendChild(thumb);
        li.appendChild(info);
        list.appendChild(li);

        function sel(act) { return '[data-key="' + item.key + '"][data-act="' + act + '"]'; }
        minus.addEventListener('click', function () { change(item.key, item.quantity - 1, item.quantity > 1 ? sel('dec') : null); });
        plus.addEventListener('click', function () { change(item.key, item.quantity + 1, sel('inc')); });
        rm.addEventListener('click', function () { change(item.key, 0, null); });
      });
      els.body.appendChild(list);
      els.body.appendChild(els.status);

      var sub = el('div', 'cart-drawer__subtotal');
      sub.appendChild(el('span', 'mono', 'Subtotal'));
      sub.appendChild(el('span', 'cart-drawer__price', money(cart.total_price)));
      var note = el('p', 'cart-drawer__note', 'Shipping and taxes are calculated at checkout.');
      var go = el('a', 'btn btn--primary cart-drawer__checkout', 'Checkout');
      go.href = root + 'checkout';
      var view = el('a', 'quick-add__link mono link-underline', 'View cart');
      view.href = root + 'cart';
      els.foot.appendChild(sub);
      els.foot.appendChild(note);
      els.foot.appendChild(go);
      els.foot.appendChild(view);
    }

    function show(cart) {
      if (!dlg) build();
      render(cart);
      setCount(cart.item_count);
      if (dlg.open) return;
      document.documentElement.classList.add('cart-drawer-open');
      dlg.showModal();
      if (reduce.matches) dlg.classList.add('is-in');
      else requestAnimationFrame(function () { requestAnimationFrame(function () { dlg.classList.add('is-in'); }); });
    }

    document.addEventListener('pfd:cart-add', function (e) {
      if (!(dlg && dlg.open)) returnTo = (e.detail && e.detail.returnTo) || document.activeElement;
      getCart().then(show).catch(function () { window.location.href = root + 'cart'; });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-cart-open]');
      if (!link) return;
      if (/\/cart\/?$/.test(location.pathname)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      e.preventDefault();
      returnTo = link;
      getCart().then(show).catch(function () { window.location.href = link.href; });
    });

    /* Product page form: add without leaving the page, then show the drawer.
       Anything unexpected falls back to the normal form submit. */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('form.product__form')) return;
      var idInput = f.querySelector('[data-product-id-input]');
      var qtyInput = f.querySelector('[name="quantity"]');
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      var btn = e.submitter || f.querySelector('[data-add-to-cart]');
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(idInput.value), quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        return r.json();
      }).then(function () {
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        document.dispatchEvent(new CustomEvent('pfd:cart-add', { detail: { returnTo: btn } }));
      }).catch(function () {
        if (btn) btn.removeAttribute('aria-busy');
        f.submit();
      });
    });
  }

  /* ---------------------------------------------------------------- Init */

  // Each piece starts on its own, so one failing never stops the rest
  // (a throw early in the list used to take the card swatches down with it).
  function safely(fn) {
    try { fn(); } catch (e) { if (window.console) console.error('[pfd-theme]', fn.name, e); }
  }

  // Product cards that arrive after load (recommendations, Load more, any
  // section fetched later) get their swatches bound as they appear.
  function watchCards() {
    if (!('MutationObserver' in window)) return;
    var queued = false;
    new MutationObserver(function (list) {
      var hit = list.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-product-card]') || n.querySelector('[data-product-card]'));
        });
      });
      if (!hit || queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; initCardSwatches(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    document.documentElement.classList.remove('no-js');
    [
      initMobileNav, initHeaderSwap, initShopDropdown, initCollectionMenu, initShowcase, initPopup,
      initReveal, initHeroCycle, initCollageRail, initFormFocus, initProductGallery,
      // initProductZoomLens removed 2026-10-03 (Patrick: no hover magnification);
      // a click still opens the full-screen lightbox.
      initProductLightbox, initProductForm, initStickyAddToCart, initBackLink,
      initPasswordToggle, initCollectionFilters, initCardSwatches, initLoadMore,
      initCardTouchSwap, initQuickAdd, initCartDrawer, watchCards
    ].forEach(safely);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* "Size guide" link next to the size picker opens the size guide dropdown. */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[href="#SizeGuide"]');
  if (!a) return;
  var d = document.getElementById('SizeGuide');
  if (d && d.tagName === 'DETAILS') {
    e.preventDefault();
    d.open = true;
    d.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    var s = d.querySelector('summary'); if (s) s.focus({ preventScroll: true });
  }
});

/* Arriving from quick view's "Size guide" link (product page + #SizeGuide):
   open the size guide dropdown. */
(function () {
  function openGuide() {
    if (window.location.hash !== '#SizeGuide') return;
    var d = document.getElementById('SizeGuide');
    if (d && d.tagName === 'DETAILS') d.open = true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openGuide);
  else openGuide();
})();

/* Product photos fill the 4:5 frame edge to edge. Square supplier renders
   carry a lot of empty margin around the garment, so they get a modest
   zoom (see .is-square in pfd-base.css). Model photos (4:5) and neck or
   sleeve detail shots are left alone. Caps keep their natural framing. */
(function () {
  var SEL = '.product-card__img, .quick-add__img, .product-gallery__media';
  function mark(img) {
    if (!img.naturalWidth || img.classList.contains('is-contain')) return;
    var r = img.naturalWidth / img.naturalHeight;
    var alt = img.alt || img.getAttribute('data-alt') || '';  // hover images carry their description in data-alt
    var smallGoods = /(cap|hat|sticker)s?/i.test(alt);
    // Flat lays ("..., front" / "..., back", not model shots): the whole shirt must be visible
    // (Patrick 2026-10-05), so they are shown uncropped on the white plate.
    // Tees only: their flat lays sit on pure white; fleece renders use other backgrounds and showed borders.
    var flatFront = /,\s*(front|back)$/i.test(alt) && /\btee\b/i.test(alt) && !/on model|worn|model/i.test(alt);
    var whole = (smallGoods || flatFront) && r > 0.9;
    var square = r > 0.9 && r < 1.12 && !whole;
    img.classList.toggle('is-square', square);
    // Caps and stickers: show the whole render (side embroidery sits at the
    // frame edge; cover-cropping cut it off, Patrick 2026-10-05).
    img.classList.toggle('is-whole', whole);
  }
  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(function (img) {
      if (img.complete) mark(img);
    });
  }
  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SEL)) mark(t);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
})();

/* Brand statement photo cycle: crossfades stacked frames. Runs only while in
   view, pauses on hover/focus/hidden tab/manual pause, and never runs under
   prefers-reduced-motion (first photo only, no button). */
(function () {
  var roots = document.querySelectorAll('[data-cycle]');
  if (!roots.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  roots.forEach(function (root) {
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.statement__cycle-img'));
    if (imgs.length < 2 || reduce.matches) return;
    var btn = root.querySelector('[data-cycle-toggle]');
    var ms = Math.min(10, Math.max(3, parseInt(root.getAttribute('data-cycle-seconds'), 10) || 5)) * 1000;
    var cur = 0, timer = null, inView = false, hovering = false, focused = false, manual = false;
    function show(n) {
      imgs[cur].classList.remove('is-active');
      imgs[cur].setAttribute('aria-hidden', 'true');
      cur = n;
      imgs[cur].classList.add('is-active');
      imgs[cur].removeAttribute('aria-hidden');
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function sync() {
      var go = inView && !hovering && !focused && !manual && !document.hidden && !reduce.matches;
      if (go && !timer) timer = setInterval(function () { show((cur + 1) % imgs.length); }, ms);
      else if (!go) stop();
    }
    root.addEventListener('mouseenter', function () { hovering = true; sync(); });
    root.addEventListener('mouseleave', function () { hovering = false; sync(); });
    root.addEventListener('focusin', function () { focused = true; sync(); });
    root.addEventListener('focusout', function () { focused = false; sync(); });
    document.addEventListener('visibilitychange', sync);
    if (reduce.addEventListener) reduce.addEventListener('change', function () { if (reduce.matches) { stop(); show(0); } });
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () {
        manual = !manual;
        btn.setAttribute('aria-pressed', manual ? 'true' : 'false');
        btn.setAttribute('aria-label', manual ? 'Play photo slideshow' : 'Pause photo slideshow');
        btn.firstElementChild.textContent = manual ? '\u25B6' : 'II';
        sync();
      });
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.3 }).observe(root);
    }
  });
})();
